import React, { useEffect, useState } from "react";
import { MODULE_API } from "../../../apis";
import DropDown from "../../../components/styled-components/dropdown/dropdown";
import helpIcon from "../../../assets/images/DeathModuleNew/infoIcon.png";
import { defaultStyles } from "../../../constants/style-constants/utils";
import {
  Radio,
  DatePicker,
  Button,
  Collapse,
  Select,
  InputNumber,
  Modal,
  Spin,
  Icon,
  Checkbox,
} from "antd";
import * as Styles from "./goalAllocationSubformStyles";
import moment from "moment";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import GoalSubFormTable from "./GoalSubFormTable";
import { AssetAssignTable } from "./AssetAssignTable";
import { AssetAssignLiquid } from "./AssetAssignLiquid";
import FETCH from "../../../utils/fetch";
import axios from "axios";
import TAX_AND_INFLATION_API from "../../../apis/tax_and_inflation.api";
import ChildExpenseSummary from "./ChildExpenseSummary";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
import { GoalMonthlySavings } from "./GoalMonthlySavings";
import {
  calculateSavingsForGoal,
  calculateCompletePercentage,
  calculateGoalDifferences,
} from "../../../helpers/goalSavingCalculation";
import { calculateAmortization } from "../../../helpers/amortizationCalcultion";
import { InsuranceFormSkeleton } from "../../InsuranceNew/InsuraceDashboardComponents/InsuranceFormSkeleton";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import RetirementProjection from "../../../helpers/RetirementGoal";
import EducationExpenseSummary from "./EducationExpenseSummary";
import EducationProjection from "./EducationProjection";
import { EducationAssetAssignTable } from "./EducationAssetAssignTable";
import { EducationAssetAssignLiquid } from "./EducationAssetAssignLiquid";
import RetirementSummary from "./RetirementSummary";
import { AssetAssignRetirement } from "./AssetAssignRetirement";
import RetirementStrategyResults from "./RetirementStrategyResults";
const { Option } = Select;

const GoalAllocationSubform = () => {
  const history = useHistory();
  const { module } = useParams();
  const { id } = useParams();
  const { view } = useParams();

  const [taxInfo, setTaxInfo] = useState(null);
  const [taxInfoAllData, setTaxInfoAllData] = useState(null);
  const [moduleName, setModuleName] = useState(null);
  const [moduleId, setModuleId] = useState(null);
  const [loading, setIsLoading] = useState(false);
  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [tabsControl, setTabsControl] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabName, setActiveTabName] = useState("");
  const [submitBody, setSubmitBody] = useState({});
  const [cashModuleData, setCashModuleData] = useState(null);
  const [liquidModuleToUpdate, setLiquidModuleToUpdate] = useState(null);
  const [liquidGoalIds, setLiquidGoalIds] = useState([]);
  const [fieldsData, setFieldsData] = useState({});
  const [attributes, setAttributes] = useState({});
  const [liabilities, setLiabilities] = useState(null);
  const [assetsAssign, setAssetsAssign] = useState([]);

  // Fetch asset fields
  const getAssetFields = async (assetName) => {
    setIsLoading(true);
    try {
      const res = await MODULE_API.assetFiledDetails(assetName);
      if (res && res.attributes) {
        const sortedAttributes =
          res.attributes &&
          res.attributes.sort(
            (a, b) => a.groupPriorityValue - b.groupPriorityValue,
          );
        setAttributes(sortedAttributes && sortedAttributes);
        sortedAttributes &&
          sortedAttributes.map((attribute) => {
            setFields((prevValue) => {
              return {
                ...prevValue,
                [attribute["groupName"]]: {
                  ...(prevValue[attribute["groupName"]] || {}),
                  [attribute["id"]]: attribute,
                },
              };
            });
          });
      }
    } finally {
      setIsLoading(false);
    }
  };
  const getLiabilityList = async (page) => {
    try {
      setIsLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Liabilities and Credit&page=${page}&limit=10&clientId=${ID}`
            : `?module=Liabilities and Credit&page=${page}&limit=10`,
        body: {},
      });
      setIsLoading(false);
      if (datares && datares.records) {
        // Cache the data for the current page
        setLiabilities(datares.records);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  //  const getInvestmentsModule = async (page) => {
  //     try {
  //       setLoading(true);
  //       const userRole =
  //         localStorage.getItem("role") != "undefined" &&
  //         JSON.parse(localStorage.getItem("role"));
  //       const ID = localStorage.getItem("accessId");
  //       let datares = await FETCH.post({
  //         url: "client-module-service/client-module/list",
  //         id:
  //           userRole === "Financial Advisor Client"
  //             ? `?module=investment&page=${page}&limit=10&clientId=${ID}`
  //             : `?module=investment&page=${page}&limit=10`,
  //         body: {},
  //       });
  //       if (datares && datares.records) {
  //         setCachedData((prevState) => ({
  //           ...prevState,
  //           [page]: datares,
  //         }));
  //         updateStateWithData(datares);
  //       }
  //       setLoading(false);
  //     } catch (error) {
  //       console.log(error);
  //       setLoading(false);
  //     }
  //   };
  const getTaxInflationDetails = async () => {
    try {
      setIsLoading(true);
      const inflationFields = [
        { id: 1, name: "Education", key: "educationInflationRate" },
        { id: 2, name: "Medical", key: "medicalInflationRate" },
        { id: 3, name: "Luxury", key: "luxuryInflationRate" },
        { id: 4, name: "Housing", key: "housingInflationRate" },
        { id: 5, name: "General", key: "generalInflationRate" },
      ];
      let data = await TAX_AND_INFLATION_API.fetchTaxInflationDetails();
      if (data && data.data) {
        //inflation details
        if (data.data[0]) {
          const taxDropdownData = data.data[0];
          const inflationArray = inflationFields.map(({ name, key }) => ({
            id,
            name,
            value: parseFloat(taxDropdownData && taxDropdownData[key]) || 0,
          }));
          setTaxInfoAllData(taxDropdownData);
          // console.log("Inflation Details:", inflationArray);
          setTaxInfo(inflationArray);
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("error while fetching Tax Inflation Details", error);
    }
  };
  // Fetch asset fields data
  const getAssetFieldsData = async (id) => {
    setIsLoading(true);
    try {
      const res = await MODULE_API.fetchSingleGoalDetails(id);
      if (res && res.data) {
        setFieldsData(res.data);
        if (res.data && res.data.assets) {
          setAssetsAssign(res.data.assets);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Create dynamic tabs from attributes
  const createDynamicTabs = (fields) => {
    const newTabs = Object.keys(fields).map((key, index) => ({
      name: key.toUpperCase(),
      enabled: true,
      priority: index + 1,
    }));
    setTabs(newTabs);
  };
  const handleFormInputChange = (title, rows) => {
    console.log("rows", rows);
    // setPayload(prevValue => ({ ...prevValue, [name]: value }));
  };
  // Handle previous button click
  // const handlePreviousFormButton = () => {
  //   let temp = Object.values(tabsControl);
  //   let a = temp.indexOf(activeTabName);
  //   let b = Object.keys(tabsControl)[a - 1];
  //   setActiveTabName(tabsControl[b]);
  // };

  // // Handle next button click
  // const handleNextFormButton = () => {
  //   let temp = Object.values(tabsControl);
  //   let a = temp.indexOf(activeTabName);
  //   let b = Object.keys(tabsControl)[a + 1];
  //   setActiveTabName(tabsControl[b]);
  // };

  const handlePreviousFormButton = () => {
    let temp = Object.values(tabsControl);
    let a = temp.indexOf(activeTabName);
    // 🔹 Move back until you find an enabled tab or no tabs left
    for (let i = a - 1; i >= 0; i--) {
      let key = Object.keys(tabsControl)[i];
      if (allTabs[tabsControl[key]].enabled) {
        setActiveTabName(tabsControl[key]);
        return;
      }
    }
    history.goBack();
  };

  // Handle next button click (skip disabled)
  const handleNextFormButton = () => {
    let temp = Object.values(tabsControl);
    let a = temp.indexOf(activeTabName);

    // 🔹 Move forward until you find an enabled tab or no tabs left
    for (let i = a + 1; i < temp.length; i++) {
      let key = Object.keys(tabsControl)[i];
      if (allTabs[tabsControl[key]].enabled) {
        setActiveTabName(tabsControl[key]);
        return;
      }
    }

    // If no next enabled tab, do nothing or handle submit if needed
  };

  const deleteAssignAsset = async (record) => {
    // console.log("record", record);
    try {
      setIsLoading(true);
      let payload = {
        goalId: +id,
        assetId: record.assetId,
      };
      const response = await MODULE_API.removeAssignedAsset(payload);
      if (response && response.status === 200) {
      }
      console.log("response", response);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);

      console.error("Error fetching user data:", error);
    }
  };
  const handleSubmitAmortization = async (id, data) => {
    try {
      if (data) {
        //  let payload={...data}
        let payload = {
          liabilityId: +id,
          amotizaion: data,
        };
        const response = await MODULE_API.postDebtData(id, payload);
        console.log("response", response);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const handleGoalAssign = async (id, data) => {
    let payload = data.map((item) => ({
      id: item.id,
      assetId: item["assetId"],
      priority: item["priority"],
      asset: item["asset"],
      valueOfAssetGoalRate: item["valueOfAssetGoalRate"],
      loanValueGoalDate: item["loanValueGoalDate"],
      amountUseForGoal: item["amountUseForGoal"],
      taxes: item["taxes"],
      netAmountAfterTax: item["netAmountAfterTax"],
    }));

    try {
      // setIsLoading(true);
      let goalAssign = {
        goalId: id,
        assets: payload,
      };
      const response = MODULE_API.assignAsset(goalAssign);
      console.log("response", response);
      // setIsLoading(false);
    } catch (error) {
      // setIsLoading(false);

      console.error("Error fetching user data:", error);
    }
  };
  const handleRetirementGoalAssign = async (id, data) => {
    let payload = data.map((item) => ({
      id: item.id,
      assetId: item["assetId"],
      priority: item["priority"],
      asset: item["asset"],
      assetName: item["assetName"],
      Strategy: item["Strategy"],
      annualSavings: item["annualSavings"],
      rateOfReturn: item["rateOfReturn"],
      valueOfAssetGoalRate: item["valueOfAssetGoalRate"],
      loanValueGoalDate: item["loanValueGoalDate"],
      amountUseForGoal: item["amountUseForGoal"],
      taxes: item["taxes"],
      netAmountAfterTax: item["netAmountAfterTax"],
      savings_override: item["savings_override"],
      saleYear: item["saleYear"],
      costToSell: item["costToSell"],
      futureValue: item["futureValue"],
      netLumpSum: item["netLumpSum"],
      listType: item["listType"],
    }));

    try {
      // setIsLoading(true);
      let goalAssign = {
        goalId: id,
        assets: payload,
      };
      const response = MODULE_API.assignAsset(goalAssign);
      console.log("Retirement assign response", response);
      // setIsLoading(false);
    } catch (error) {
      // setIsLoading(false);
      console.error("Error assigning retirement goal assets:", error);
    }
  };
  const handleUpdateGoalAssign = async (id, data) => {
    let payload = data.map((item) => ({
      id: item.id,
      assetId: item["assetId"],
      goalId: id,
      asset: item["asset"],
      valueOfAssetGoalRate: item["valueOfAssetGoalRate"],
      loanValueGoalDate: item["loanValueGoalDate"],
      amountUseForGoal: item["amountUseForGoal"],
      taxes: item["taxes"],
      netAmountAfterTax: item["netAmountAfterTax"],
    }));

    try {
      // setIsLoading(true);
      let goalAssign = {
        goalId: id,
        assets: payload,
      };
      const response = MODULE_API.updateAssignAsset(payload);
      console.log("response", response);
      // setIsLoading(false);
    } catch (error) {
      // setIsLoading(false);

      console.error("Error fetching user data:", error);
    }
  };
  const handleRetirementUpdateGoalAssign = async (id, data) => {
    let payload = data.map((item) => ({
      id: item.id,
      assetId: item["assetId"],
      goalId: id,
      asset: item["asset"],
      assetName: item["assetName"],
      Strategy: item["Strategy"],
      annualSavings: item["annualSavings"],
      rateOfReturn: item["rateOfReturn"],
      valueOfAssetGoalRate: item["valueOfAssetGoalRate"],
      loanValueGoalDate: item["loanValueGoalDate"],
      amountUseForGoal: item["amountUseForGoal"],
      taxes: item["taxes"],
      netAmountAfterTax: item["netAmountAfterTax"],
      savings_override: item["savings_override"],
      saleYear: item["saleYear"],
      costToSell: item["costToSell"],
      futureValue: item["futureValue"],
      netLumpSum: item["netLumpSum"],
      listType: item["listType"],
    }));

    try {
      // setIsLoading(true);
      const response = MODULE_API.updateAssignAsset(payload);
      console.log("Retirement update response", response);
      // setIsLoading(false);
    } catch (error) {
      // setIsLoading(false);
      console.error("Error updating retirement goal assets:", error);
    }
  };
  const calculateMonthlyPayment = (
    startDate,
    maturityDate,
    interestRate,
    initialLoanAmount,
  ) => {
    let Interest = interestRate;
    let loanAmount = initialLoanAmount;
    let Start = startDate;
    let Maturity = maturityDate;

    let StartDate1 = new Date(Start);
    let MaturityDate1 = new Date(Maturity);

    let numberOfPayments = 0;

    if (StartDate1 && MaturityDate1) {
      // Calculate the difference in months
      numberOfPayments =
        (MaturityDate1.getFullYear() - StartDate1.getFullYear()) * 12;
      numberOfPayments -= StartDate1.getMonth();
      numberOfPayments += MaturityDate1.getMonth();

      // Check if there's a partial month based on days
      if (MaturityDate1.getDate() >= StartDate1.getDate()) {
        numberOfPayments += 1;
      }
    }
    let rate = Interest / 100 / 12;
    let monthlyRate = Interest / 100 / 12;
    // Using the formula to calculate the monthly payment
    let MonthlyPayment =
      (loanAmount * monthlyRate) /
      (1 - Math.pow(1 + monthlyRate, -numberOfPayments));
    // loanAmount * rate / (1 - Math.pow(1 + rate, -numberOfPayments));
    // console.log("MonthlyPayment", MonthlyPayment);
    MonthlyPayment =
      isNaN(MonthlyPayment) || !isFinite(MonthlyPayment)
        ? 0
        : MonthlyPayment.toFixed(2);
    if (isNaN(MonthlyPayment) || MonthlyPayment.toString() === "Infinity") {
      return 0;
    } else {
      return +MonthlyPayment;
    }
  };
  const handleAddLoanToGoal = async (data) => {
    // console.log("goalId",goalId,data);
    const modulePersonal = "Personal";
    const startDate =
      data && data["Goal Date"] ? new Date(data["Goal Date"]) : new Date();
    const maturityDate =
      data && data["Loan End Date"]
        ? new Date(data["Loan End Date"])
        : new Date();
    // maturityDate.setFullYear(maturityDate.getFullYear() + 5);
    const interestRate =
      data && data["Loan Interest Rate"] ? +data["Loan Interest Rate"] : 0;
    const initialLoanAmount =
      data && data["Total Loan assigned to goal"]
        ? +data["Total Loan assigned to goal"]
        : 0;
    // Create payload
    let payload = {
      "Nickname of Liabilities":
        data && data["Description of Goal"]
          ? data["Description of Goal"]
          : null,
      "Initial Loan Amount": initialLoanAmount,
      "Start Date": startDate,
      "Maturity Date": maturityDate,
      "Interest Rate": interestRate,
      "Monthly Payment": calculateMonthlyPayment(
        startDate,
        maturityDate,
        interestRate,
        initialLoanAmount,
      ),
      future_loan: true,
    };
    try {
      const liabilityCreated = await MODULE_API.addAsset(modulePersonal, {
        clientModules: [payload],
      });
      const loanId =
        liabilityCreated &&
        liabilityCreated.clientModules[0] &&
        liabilityCreated.clientModules[0].id;
      const { formattedLiabilityData, monthlyPayment } = calculateAmortization(
        loanId,
        payload,
        modulePersonal,
      );
      await handleSubmitAmortization(loanId, formattedLiabilityData);
      return loanId;
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const handleUpdateLoanToUpdateGoal = async (goalId, data) => {
    // console.log("goalId",goalId,data);
    const modulePersonal = "Personal";
    const startDate = new Date();
    const maturityDate =
      data && data["Loan End Date"]
        ? new Date(data["Loan End Date"])
        : new Date();
    const interestRate =
      data && data["Loan Interest Rate"] ? +data["Loan Interest Rate"] : 0;
    const initialLoanAmount =
      data && data["Total Loan assigned to goal"]
        ? +data["Total Loan assigned to goal"]
        : 0;
    // Create payload
    let payload = {
      goal_id: +goalId,
      "Nickname of Liabilities":
        data && data["Description of Goal"]
          ? "Created for Goal " + data["Description of Goal"]
          : null,
      "Initial Loan Amount": initialLoanAmount,
      "Start Date": startDate,
      "Maturity Date": maturityDate,
      "Interest Rate": interestRate,
      "Monthly Payment": calculateMonthlyPayment(
        startDate,
        maturityDate,
        interestRate,
        initialLoanAmount,
      ),
    };
    try {
      const liabilityCreated = await MODULE_API.addAsset(modulePersonal, {
        clientModules: [payload],
      });

      const loanId =
        liabilityCreated &&
        liabilityCreated.clientModules[0] &&
        liabilityCreated.clientModules[0].id;
      const { formattedLiabilityData, monthlyPayment } = calculateAmortization(
        loanId,
        payload,
        modulePersonal,
      );
      await handleSubmitAmortization(loanId, formattedLiabilityData);
      return loanId;
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const handleUpdateLoanToGoal = async (loanId, data) => {
    // console.log("goalId",goalId,data);
    const modulePersonal = "Personal";
    const startDate = new Date();
    const maturityDate =
      data && data["Goal Date"] ? new Date(data["Goal Date"]) : new Date();
    const interestRate = 5;
    const initialLoanAmount =
      data && data["Total Loan assigned to goal"]
        ? +data["Total Loan assigned to goal"]
        : 0;
    // Create payload
    let payload = {
      "Nickname of Liabilities":
        data && data["Description of Goal"]
          ? "Created for Goal " + data["Description of Goal"]
          : null,
      "Initial Loan Amount": initialLoanAmount,
      "Start Date": startDate,
      "Maturity Date": maturityDate,
      "Interest Rate": interestRate,
      "Monthly Payment": calculateMonthlyPayment(
        startDate,
        maturityDate,
        interestRate,
        initialLoanAmount,
      ),
    };
    try {
      const liablityUpdated = await MODULE_API.updateClientModule(+loanId, {
        ...payload,
      });
      console.log("payloadTo create Liability", liablityUpdated);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const handleUpdateLoanAfterGoal = async (goalId, loanId) => {
    // Create payload
    let payload = {
      goal_id: +goalId,
    };
    try {
      const liablityUpdated = await MODULE_API.updateClientModule(loanId, {
        ...payload,
      });
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  // Handle submit
  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      // Document 2: Pass key to backend for task generation if commitment increased
      // if (
      //   module === "Retirement" &&
      //   submitBody["Your Commitment"] > (fieldsData["Your Commitment"] || 0)
      // ) {
      //   submitBody.generateActionItem = true;
      // }

      let loanId;
      if (moduleName && !moduleId) {
        if (
          submitBody.hasOwnProperty("Will you need a loan for this goal?") &&
          submitBody["Will you need a loan for this goal?"] === true &&
          submitBody.hasOwnProperty("Total Loan assigned to goal") &&
          submitBody["Total Loan assigned to goal"] > 0
        ) {
          loanId = await handleAddLoanToGoal(submitBody);
          console.log("loanId", loanId);
        }
        const moduleNew = await MODULE_API.addAsset(moduleName, {
          clientModules: [
            {
              ...submitBody,
              goal_status: "pending",
              loan_id: loanId ? +loanId : null,
            },
          ],
        });
        if (loanId) {
          let goalId =
            moduleNew &&
            moduleNew.clientModules[0] &&
            moduleNew.clientModules[0].id;
          await handleUpdateLoanAfterGoal(goalId, loanId);
        }
        if (submitBody.hasOwnProperty("assetId")) {
          let assetsToUpdateId = submitBody["assetId"];
          let goalId =
            moduleNew &&
            moduleNew.clientModules[0] &&
            moduleNew.clientModules[0].id;
          if (assetsAssign) {
            if (module === "Retirement") {
              await handleRetirementGoalAssign(goalId, assetsAssign);
            } else {
              await handleGoalAssign(goalId, assetsAssign);
            }
          }
          let assetsToUpdate = {
            clientModuleIds: assetsToUpdateId,
            goalId: goalId,
          };
          // Call the API with the goal_id and the current moduleId
          await MODULE_API.UpdateAssetGoal(assetsToUpdate);
          if (cashModuleData) {
            const moduleCash = "Cash";
            const created_from_goal = [goalId];
            let cashData = {
              ...cashModuleData,
              created_from_goal: created_from_goal,
              future_asset: true,
            };
            await MODULE_API.addAsset(moduleCash, {
              clientModules: [cashData],
            });
          }
        }
        // console.log("liquidModuleToUpdate",liquidModuleToUpdate,liquidGoalIds)
        if (liquidModuleToUpdate && Array.isArray(liquidModuleToUpdate)) {
          let goal =
            moduleNew &&
            moduleNew.clientModules[0] &&
            moduleNew.clientModules[0].id;
          let assetsLiquid = {
            goal_id: [...liquidGoalIds, goal],
          };
          try {
            // Use Promise.all with map to make concurrent API calls
            await Promise.all(
              liquidModuleToUpdate.map(async (Id) => {
                await MODULE_API.updateClientModule(Id, assetsLiquid);
                console.log(`Successfully updated moduleId: ${Id}`);
              }),
            );
          } catch (error) {
            console.error(`Failed to update modules`, error);
          }
        }
      } else if (moduleId && moduleName && !view) {
        let loanCreated;
        if (
          submitBody.hasOwnProperty("Will you need a loan for this goal?") &&
          submitBody["Will you need a loan for this goal?"] === true &&
          submitBody.hasOwnProperty("Total Loan assigned to goal") &&
          submitBody["Total Loan assigned to goal"] > 0 &&
          (!submitBody.hasOwnProperty("loan_id") ||
            submitBody["loan_id"] === null)
        ) {
          loanCreated = await handleUpdateLoanToUpdateGoal(
            moduleId,
            submitBody,
          );
        }
        await MODULE_API.updateClientModule(moduleId, {
          ...submitBody,
          loan_id: loanCreated && +loanCreated,
        });
        if (module === "Retirement") {
          await handleRetirementUpdateGoalAssign(moduleId, assetsAssign);
        } else {
          await handleUpdateGoalAssign(moduleId, assetsAssign);
        }
        if (
          submitBody.hasOwnProperty("Will you need a loan for this goal?") &&
          submitBody["Will you need a loan for this goal?"] === true &&
          submitBody.hasOwnProperty("Total Loan assigned to goal") &&
          submitBody["Total Loan assigned to goal"] > 0 &&
          submitBody.hasOwnProperty("loan_id") &&
          submitBody["loan_id"] !== null
        ) {
          await handleUpdateLoanToGoal(submitBody["loan_id"], submitBody);
        }
        if (submitBody.hasOwnProperty("assetId")) {
          console.log("submitBody", submitBody["assetId"]);
          let assetsToUpdateId = submitBody["assetId"];
          let goalId = +moduleId;
          let assetsToUpdate = {
            clientModuleIds: assetsToUpdateId,
            goalId: +goalId,
          };
          // Call the API with the goal_id and the current moduleId
          await MODULE_API.UpdateAssetGoal(assetsToUpdate);
          if (cashModuleData) {
            const moduleCash = "Cash";
            const created_from_goal = [goalId];
            let cashData = {
              ...cashModuleData,
              created_from_goal: created_from_goal,
              future_asset: true,
            };
            await MODULE_API.addAsset(moduleCash, {
              clientModules: [cashData],
            });
          }
        }
        // console.log("liquidModuleToUpdate",liquidModuleToUpdate,liquidGoalIds)
        if (liquidModuleToUpdate && Array.isArray(liquidModuleToUpdate)) {
          let goal = +moduleId;
          let assetsLiquid = {
            goal_id: [...liquidGoalIds, goal],
          };
          try {
            // Use Promise.all with map to make concurrent API calls
            await Promise.allSettled(
              liquidModuleToUpdate.map(async (Id) => {
                await MODULE_API.updateClientModule(Id, assetsLiquid);
                console.log(`Successfully updated moduleId: ${Id}`);
              }),
            );
          } catch (error) {
            console.error(`Failed to update modules`, error);
          }
        }
      }
      history.push("/goals");
    } catch (error) {
      swal({
        title: "Error",
        text: "Error while Saving Module",
        icon: "error",
        buttons: true,
        dangerMode: true,
      });
    } finally {
      setIsLoading(false);
    }
  };
  const colsAssetToAssignFormat = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      fields: [
        {
          type: "DatePicker",
          name: "Date",
        },
      ],
    },
    {
      title: "Person Providing Assistance",
      dataIndex: "Person Providing Assistance",
      key: "Person Providing Assistance",
      fields: [
        {
          type: "Input",
          name: "Person Providing Assistance",
        },
      ],
    },
    {
      title: "Relationship",
      dataIndex: "Relationship",
      key: "Relationship",
      fields: [
        {
          type: "Input",
          name: "Relationship",
        },
      ],
    },
    {
      title: "Amount Received",
      dataIndex: "Amount Received",
      key: "Amount Received",
      fields: [
        {
          type: "Currency",
          name: "Amount Received",
        },
      ],
    },
  ];
  // Set current tab
  const currentTab = (tab) => {
    let tabs2 = tabs && tabs.map((tab) => tab.name);
    let cond = tabs2.includes(tab);
    if (cond) {
      let ind = tabs2.indexOf(tab);
      setActiveTabIndex(ind);
      setActiveTabName(tab);
    }
  };

  // Update tabs when fields change
  useEffect(() => {
    setTabs(Object.keys(fields));
    createDynamicTabs(fields);
  }, [fields]);

  // Set active tab on initial load
  useEffect(() => {
    if (tabs.length > 0) {
      currentTab(tabs[0].name);
    }
  }, [tabs]);
  useEffect(() => {
    const tabNamesArray = tabs && tabs.map((tab) => tab.name);
    let temp = tabNamesArray.indexOf(activeTabName);
    if (temp !== -1) {
      setActiveTabIndex(temp);
    }
  }, [activeTabName]);

  // Fetch initial data
  useEffect(() => {
    // kindly correct moduleName  beacuse name of module must not contain / in it
    fetchAll();
    // if (module) {
    //   getAssetFields(module);
    //   setModuleName(module);
    // }
    // if (id) {
    //   getAssetFieldsData(id);
    //   setModuleId(id);
    // }
  }, [module, id]);

  const fetchAll = async () => {
    await getLiabilityList(1);
    await getTaxInflationDetails();
    if (module) {
      await getAssetFields(module);
      setModuleName(module);
    }
    if (id) {
      await getAssetFieldsData(id);
      setModuleId(id);
    }
  };

  // Create tabs control for navigation
  useEffect(() => {
    const tabsControl = {};
    tabs.forEach((tab, index) => {
      tabsControl[index + 1] = tab.name;
    });
    setTabsControl(tabsControl);
  }, [tabs]);

  const adoptionKey =
    submitBody &&
    Object.keys(submitBody).find((key) => key.startsWith("Adoption:"));

  const allTabs =
    tabs &&
    tabs.reduce((acc, tab, index) => {
      const isBirthTab = tab.name.toUpperCase() === "BIRTH";
      const disableBirth = isBirthTab && adoptionKey && submitBody[adoptionKey];
      acc[tab.name] = {
        name: tab.name,
        enabled: !disableBirth,
        priority: tab.priority,
      };
      return acc;
    }, {});
  const tabNamesArray = tabs && tabs.map((tab) => tab.name);
  return attributes && attributes.length > 0 ? (
    <div style={{ position: "relative" }}>
      <hr />
      <TabNavigationComponent
        tabs={tabNamesArray}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
        activeTabName={activeTabName}
        setActiveTabName={setActiveTabName}
        currentTab={currentTab}
        AllTabs={allTabs}
      />
      <hr />
      <form>
        {tabNamesArray.length > 0 && (
          <FormCreator
            data={fields[tabNamesArray[activeTabIndex]]}
            attributes={attributes && attributes}
            values={fieldsData}
            title={tabs[activeTabIndex]}
            setSubmitBody={setSubmitBody}
            setCashModuleData={setCashModuleData}
            setLiquidModuleToUpdate={setLiquidModuleToUpdate}
            setLiquidGoalIds={setLiquidGoalIds}
            liabilities={liabilities && liabilities}
            activeTabName={activeTabName}
            taxInfo={taxInfo && taxInfo}
            deleteAsset={deleteAssignAsset}
            setAssetsAssign={setAssetsAssign}
            assetsAssign={assetsAssign}
            taxInfoAllData={taxInfoAllData && taxInfoAllData}
          />
        )}
      </form>
      {/*<div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "3rem 3rem",
          width: "96%",
        }}
      >
        <GoalSubFormTable
          title="Asset to Assign to Goal"
          rows={[]}
          colsFormat={colsAssetToAssignFormat}
          addNewButton={true}
          cbFormChange={(rows) =>
            handleFormInputChange("asset_to_assign_to_goal", rows)
          }
        />
      </div> */}
      {tabs.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "3rem 3rem",
            width: "96%",
          }}
        >
          <Button
            onClick={() => {
              if (activeTabName === tabs[0].name) {
                history.goBack();
              } else {
                handlePreviousFormButton();
              }
            }}
            style={{
              backgroundColor: "transparent",
              color: "#2a3da3",
              borderRadius: "8px",
              border: "1px solid #2a3da3",
              width: "250px",
              height: "3rem",
              fontSize: "16px",
              fontWeight: "500",
              fontFamily: "Poppins",
            }}
            // disabled={activeTabName === tabs[0].name}
          >
            Previous
          </Button>
          {activeTabName === tabs[tabs.length - 1].name ? (
            <Button
              onClick={handleSubmit}
              style={{
                backgroundColor: "#2a3da3",
                color: "white",
                borderRadius: "8px",
                width: "250px",
                height: "3rem",
                fontFamily: "Poppins",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Submit
            </Button>
          ) : (
            <Button
              onClick={handleNextFormButton}
              style={{
                backgroundColor: "#2a3da3",
                color: "white",
                borderRadius: "8px",
                width: "250px",
                height: "3rem",
                fontFamily: "Poppins",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Next
            </Button>
          )}
        </div>
      )}
      <NewLoader isLoading={loading} />
    </div>
  ) : (
    <InsuranceFormSkeleton />
  );
};

const FormCreator = ({
  data,
  title,
  setSubmitBody,
  setCashModuleData,
  setLiquidModuleToUpdate,
  setLiquidGoalIds,
  liabilities,
  activeTabName,
  values,
  taxInfo,
  attributes,
  deleteAsset,
  setAssetsAssign,
  assetsAssign,
  taxInfoAllData,
}) => {
  const { Panel } = Collapse;
  const { id } = useParams();
  const [inputFields, setInputFields] = useState([]);
  const [groupedFields, setGroupedFields] = useState({});
  const [payload, setPayload] = useState({});
  const [attributeValues, setAttributeValues] = useState({});
  const [tabRows, setTabRows] = useState({});
  const [tooltipModal, setTooltipModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [totalSavings, setTotalSaving] = useState(null);
  const [totalLastMonthSaving, setTotalLastMonthSaving] = useState(null);
  const [rateOfReturnData, setRateOfReturnData] = useState(null);
  const { view } = useParams();
  const { module } = useParams();

  const isAssignAssetTab =
    activeTabName === "ASSIGN ASSET" ||
    (module === "Education" &&
      activeTabName === "DEDICATED SAVINGS & INVESTMENTS");

  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };

  useEffect(() => {
    if (data && Object.keys(data)) {
      setInputFields(Object.keys(data));
    }
  }, [data]);

  useEffect(() => {
    setSubmitBody(payload);
  }, [payload]);
  console.log("payload in form creator", payload);

  // Auto-Sum logic for Education Goal
  useEffect(() => {
    if (module === "Education") {
      const tuition = parseFloat(payload["Tuition and Fees"]) || 0;
      const housing = parseFloat(payload["Housing (Room)"]) || 0;
      const mealPlan = parseFloat(payload["Meal Plan (Board)"]) || 0;
      const books = parseFloat(payload["Books, Supplies, & Equipment"]) || 0;
      const personal =
        parseFloat(payload["Personal & Transportation Expenses"]) || 0;

      const total = tuition + housing + mealPlan + books + personal;

      if (
        total > 0 &&
        payload["Estimated Annual Cost of Attendance (Today's Dollars)"] !==
          total
      ) {
        setPayload((prev) => ({
          ...prev,
          "Estimated Annual Cost of Attendance (Today's Dollars)": total,
        }));
      }
    }
  }, [
    payload["Tuition and Fees"],
    payload["Housing (Room)"],
    payload["Meal Plan (Board)"],
    payload["Books, Supplies, & Equipment"],
    payload["Personal & Transportation Expenses"],
    module,
  ]);

  const getRateofReturnDetails = async () => {
    try {
      // setLoading(true);
      let data = await TAX_AND_INFLATION_API.getRatesofReturn();
      if (data && data.data) {
        setRateOfReturnData(data.data);
      }
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      console.log("error while fetching Rate of Retrun Details", error);
    }
  };

  useEffect(() => {
    getRateofReturnDetails();
  }, []);

  useEffect(() => {
    const categories = [
      "Housing (Rent/Mortgage)",
      "Groceries",
      "Utilities",
      "Transportation",
      "Salary",
    ];

    // ✅ Check if any relevant goal value exists
    const hasGoalData = categories.some(
      (cat) => payload[`${cat} Current`] || payload[`${cat} Proposed`],
    );

    if (hasGoalData) {
      const response = calculateGoalDifferences(payload);
      setPayload((prevValue) => {
        const updatedPayload = {
          ...prevValue,
          "Housing Difference %":
            parseFloat(response.housingPercentage).toFixed(2) || 0,
          "Housing Difference $":
            parseFloat(response.housingDifference).toFixed(2) || 0,
          "Groceries Difference %":
            parseFloat(response.groceriesPercentage).toFixed(2) || 0,
          "Groceries Difference $":
            parseFloat(response.groceriesDifference).toFixed(2) || 0,
          "Utilities Difference %":
            parseFloat(response.utilitiesPercentage).toFixed(2) || 0,
          "Utilities Difference $":
            parseFloat(response.utilitiesDifference).toFixed(2) || 0,
          "Transportation Difference %":
            parseFloat(response.transportationPercentage).toFixed(2) || 0,
          "Transportation Difference $":
            parseFloat(response.transportationDifference).toFixed(2) || 0,
          "Salary Difference %":
            parseFloat(response.salaryPercentage).toFixed(2) || 0,
          "Salary Difference $":
            parseFloat(response.salaryDifference).toFixed(2) || 0,
        };

        // 🛑 Prevent infinite loop by only updating if something changed
        const isSame = Object.keys(updatedPayload).every(
          (key) => updatedPayload[key] === prevValue[key],
        );

        return isSame ? prevValue : updatedPayload;
      });
    }
  }, [payload]);

  useEffect(() => {
    // setAttributeValues({...values,"State of Residence in Retirement" :taxInfoAllData && taxInfoAllData.state});
    // setPayload({...values,"State of Residence in Retirement" :taxInfoAllData && taxInfoAllData.state});
    setPayload((prev) => ({
      ...prev,
      ...values,
      "State of Residence in Retirement":
        taxInfoAllData && taxInfoAllData.state,
    }));

    setAttributeValues((prev) => ({
      ...prev,
      ...values,
      "State of Residence in Retirement":
        taxInfoAllData && taxInfoAllData.state,
    }));
  }, [values, taxInfoAllData]);

  const getUserTotalMonthlySaving = async () => {
    try {
      let datares = await MODULE_API.fetchUserMontlhySaving();
      if (datares && datares.message) {
        const filtered = datares.message.filter(
          (item) => item.id !== Number(id),
        );

        const totalMonthlySaving = filtered.reduce(
          (sum, item) => sum + (item.total_monthly_saving_goals || 0),
          0,
        );

        // console.log("totalMonthlySaving", totalMonthlySaving);
        setTotalSaving(totalMonthlySaving);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getTotalLastMonthSaving = async () => {
    try {
      const date = moment();
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchUserTotalIncomeExpense(
        startDate,
        endDate,
        "lastMonth",
      );
      if (datares && datares) {
        const monthlyIncome = datares.total_income || 0;
        const monthlyExpense = datares.total_expenses || 0;
        const totalSaving = monthlyIncome - Math.abs(monthlyExpense);
        // console.log("totalllllNew", totalSaving);
        setTotalLastMonthSaving(totalSaving);
      }
    } catch (error) {
      console.log(error);
    }
  };
  // helper function for value
  const getInputValue = (itemName) => {
    if (itemName === "Current Monthly Saving Capacity (Based on Last Month)") {
      return totalLastMonthSaving || 0;
    }

    if (itemName === "Total Monthly Saving for All Goals") {
      const actualMonthlySavings =
        payload && payload["Actual Monthly Savings"] !== undefined
          ? payload["Actual Monthly Savings"]
          : attributeValues &&
              attributeValues["Actual Monthly Savings"] !== undefined
            ? attributeValues["Actual Monthly Savings"]
            : 0;

      return (totalSavings || 0) + actualMonthlySavings;
    }

    return payload[itemName]
      ? payload[itemName]
      : attributeValues[itemName]
        ? attributeValues[itemName]
        : "0.00";
  };

  useEffect(() => {
    let allValues = payload || values;
    const inputFieldIds =
      inputFields && inputFields.map((id) => parseInt(id, 10));
    const filteredAttributes =
      attributes &&
      attributes.filter((attr) => inputFieldIds.includes(attr.id));
    const attributeNames =
      filteredAttributes && filteredAttributes.map((attr) => attr.name);

    // Filter allValues to get only the attributes matching attributeNames
    const matchingValues = {};
    attributeNames.forEach((name) => {
      if (allValues.hasOwnProperty(name)) {
        matchingValues[name] = allValues[name];
      }
    });

    // Convert the payload to rows for all array values
    const payloadTab = {};
    Object.keys(matchingValues).forEach((key) => {
      if (Array.isArray(matchingValues[key])) {
        payloadTab[key] = matchingValues[key];
      }
    });
    const rows = convertPayloadToRows(payloadTab);
    setTabRows((prevTabRows) => ({
      ...prevTabRows,
      [activeTabName]: rows,
    }));
    // You can set the rows state here, e.g., setRows(rows);
    // Assuming you have a setRows function in your component
  }, [data, inputFields, values]);

  const [assetsToselect, setAssetsToSelect] = useState([]);
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [loadingAssets, setLoadingAssets] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [incomeList, setIncomeList] = useState([]);

  const handlePopupScroll = (e) => {
    const { target } = e;
    if (
      !loadingAssets &&
      hasMore &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight
    ) {
      const nextPage = page + 1;
      setPage(nextPage);
      getInvesmentAssetsList(nextPage, true);
    }
  };
  const getInvesmentAssetsList = async (page = 1, isAppending = false) => {
    try {
      setLoadingAssets(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Investment&page=${page}&limit=10&clientId=${ID}`
            : `?module=Investment&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        setAssetsToSelect((prevAssets) =>
          isAppending ? [...prevAssets, ...datares.records] : datares.records,
        );
      }
      if (datares && datares.pagination) {
        const { limit, total } = datares.pagination;
        setHasMore(page * limit < total); // Check if there are more pages to load
      }
      setLoadingAssets(false);
    } catch (error) {
      console.log(error);
      setLoadingAssets(false);
    }
  };
  const socialSecurityModule = "Social Security Calculator";
  const fetchSocialSecurityData = async () => {
    try {
      // setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: socialSecurityModule,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        const socialSecuritydata = res.records[0];
        // const resultsAll = calculateSocialSecurityResults(res.records[0]);
        setPayload((prevValue) => {
          return {
            ...prevValue,
            ["Your Estimated Social Security"]:
              (socialSecuritydata &&
                socialSecuritydata["Your Monthly Benefit at FRA ($)"] &&
                parseFloat(
                  socialSecuritydata["Your Monthly Benefit at FRA ($)"],
                ).toFixed(2)) ||
              0,
            ["Social Security - Spouse"]:
              (socialSecuritydata &&
                socialSecuritydata["Spouse Monthly Benefit at FRA ($)"] &&
                parseFloat(
                  socialSecuritydata["Spouse Monthly Benefit at FRA ($)"],
                ).toFixed(2)) ||
              0,
            ["Tax Filing Status"]:
              (socialSecuritydata &&
                socialSecuritydata["Tax Filing Status"] &&
                socialSecuritydata["Tax Filing Status"]) ||
              "Single",
          };
        });
        // setResults(resultsAll);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      // setLoading(false);
    }
  };
  const getIncomeList = async (page) => {
    try {
      const attributeToFetch = [
        "Date Income Starts",
        "Gross Monthly Wages",
        "Date Income Ends",
        "Income Name",
        "Passive or Active",
        "Frequency of Pay Periods",
        "Net Amount",
      ];
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Income&page=${page}&limit=10&clientId=${ID}`
            : `?module=Income&page=${page}&limit=10`,
        body: { attributes: attributeToFetch },
      });

      if (datares && datares.records) {
        setIncomeList(datares.records);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getInvesmentAssetsList();
    getUserTotalMonthlySaving();
    getTotalLastMonthSaving();
    if (module === "Retirement") {
      getIncomeList(1);
      fetchSocialSecurityData();
    }
  }, []);

  // my old code with formGroupName table making for each group

  // useEffect(() => {
  //   console.log("hardcoded inputFields", inputFields, data, attributes);
  //   const inputFieldIds =
  //     inputFields && inputFields.map((id) => parseInt(id, 10));
  //   const filteredAttributes =
  //     attributes &&
  //     attributes.filter((attr) => inputFieldIds.includes(attr.id));
  //   const cols = filteredAttributes
  //     .filter((attr) => attr.formGroupName) // Ensure formGroupName is not null or undefined
  //     .map((attr) => ({
  //       title: attr.name,
  //       dataIndex: attr.name,
  //       key: attr.name,
  //       fields: [
  //         {
  //           type: attr.type === "Date" ? "DatePicker" : "Input",
  //           name: attr.name,
  //         },
  //       ],
  //     }));
  //   console.log("cols", cols);
  //   setGroupedFields(cols);

  // }, [data, inputFields]);

  useEffect(() => {
    const inputFieldIds =
      inputFields && inputFields.map((id) => parseInt(id, 10));
    const filteredAttributes =
      attributes &&
      attributes.filter((attr) => inputFieldIds.includes(attr.id));

    // Filter out attributes where formGroupName is null
    const validAttributes =
      filteredAttributes &&
      filteredAttributes.filter((attr) => attr.formGroupName);

    // Group attributes by formGroupName
    const groupedAttributes = validAttributes.reduce((acc, attr) => {
      const group = attr.formGroupName;
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(attr);
      return acc;
    }, {});

    // Generate columns for each formGroupName
    const groupedCols = Object.entries(groupedAttributes).map(
      ([groupName, attrs]) => {
        const cols = attrs.map((attr) => ({
          title: attr.name,
          dataIndex: attr.name,
          key: attr.name,
          fields: [
            {
              type: attr.dataType,
              name: attr.name,
            },
          ],
        }));
        return {
          groupName,
          cols,
          groupAttributes: groupedAttributes[groupName],
        };
      },
    );

    console.log("groupedCols", groupedCols);
    setGroupedFields(groupedCols);
  }, [data, inputFields, attributes]);

  // function getMonthsDifference(date1, date2) {
  //   const year1 = date1.getFullYear();
  //   const year2 = date2.getFullYear();
  //   const month1 = date1.getMonth();
  //   const month2 = date2.getMonth();

  //   return (year2 - year1) * 12 + (month2 - month1);
  // }
  function getMonthsDifference(date1, date2) {
    let years = date2.getFullYear() - date1.getFullYear();
    let months = date2.getMonth() - date1.getMonth();
    let totalMonths = years * 12 + months;

    // Adjust if end day is less than start day (Excel style)
    if (date2.getDate() < date1.getDate()) {
      totalMonths--;
    }

    return totalMonths;
  }

  const calculateGoalNeed = (amountNeed, date) => {
    const GoalNeedToday = amountNeed ? amountNeed : 0;
    const goalInflation = payload && payload["Inflation rate for this goal"];

    const matchedInflation =
      taxInfo && taxInfo.find((item) => item.name === goalInflation);
    const GoalInflationRate = matchedInflation
      ? (parseFloat(matchedInflation.value) || 0) / 100
      : 0; // Fallback to 0 if no match found
    // let GoalDate = date
    //   ? new Date(date)
    //   : new Date();
    //   if (!(GoalDate instanceof Date)) {
    //     GoalDate = new Date(GoalDate);
    //   }
    // const todaysDate = new Date();
    // const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    // if (!(GoalDate instanceof Date)) {
    //   GoalDate = new Date(GoalDate);
    // }
    // // Calculate the number of days between GoalDate and todaysDate
    // const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);
    // // Calculate the formula
    // // const result = GoalNeedToday * Math.pow(1 + (GoalInflationRate / 365), 365 * (daysBetween / 365) - NumberofMonths);
    // const result =
    //   GoalNeedToday *
    //   Math.pow(
    //     1 + GoalInflationRate / 100 / 365,
    //     365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
    //       NumberofMonths
    //   );
    // console.log("result", result);
    let GoalDate = date ? new Date(date) : new Date();
    if (!(GoalDate instanceof Date) || isNaN(GoalDate)) {
      GoalDate = new Date();
    }

    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    const NumberofYears = NumberofMonths / 12; // Convert months to years

    const n = 12; // Compounded monthly
    const A =
      GoalNeedToday * Math.pow(1 + GoalInflationRate / n, n * NumberofYears);

    console.log("Future Amount Needed:", A.toFixed(2));
    setPayload((prevValue) => {
      return {
        ...prevValue,
        ["Amount Needed in Future with Inflation"]: parseFloat(A).toFixed(2),
      };
    });
    // return parseFloat(result).toFixed(2);
  };
  useEffect(() => {
    if (payload["Dollar Amount Needed"] || payload["Goal Date"]) {
      let amountNeed = payload["Dollar Amount Needed"]
        ? payload["Dollar Amount Needed"]
        : 0;
      let date = payload["Goal Date"]
        ? new Date(payload["Goal Date"])
        : new Date();
      calculateGoalNeed(amountNeed, date);
    }
  }, [
    payload["Dollar Amount Needed"],
    payload["Goal Date"],
    payload["Inflation rate for this goal"],
  ]);
  useEffect(() => {
    if (payload["Dollar Amount Needed"] || payload["Goal Date"]) {
      const haveAmount =
        (Array.isArray(payload["Amount Received"])
          ? payload["Amount Received"].reduce((acc, curr) => acc + +curr, 0)
          : 0) +
        (payload["Total Monthly Saving for All Goals"]
          ? parseFloat(payload["Total Monthly Saving for All Goals"])
          : 0) +
        (Array.isArray(assetsAssign)
          ? assetsAssign.reduce(
              (acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0),
              0,
            )
          : 0);
      const percentageFunded = calculateCompletePercentage(
        payload["Amount Needed in Future with Inflation"]
          ? payload["Amount Needed in Future with Inflation"]
          : 0,
        haveAmount,
      );
      setPayload((prevValue) => {
        return {
          ...prevValue,
          ["Percent Funded"]: parseFloat(percentageFunded).toFixed(2),
        };
      });
    }
  }, [
    payload["Amount Received"],
    payload["Total Monthly Saving for All Goals"],
    assetsAssign,
  ]);

  const handleCashModuleCreate = (cashModuleData) => {
    setCashModuleData(cashModuleData);
  };
  const handleLiquidModuleToUpdate = (moduleData, recordId) => {
    setLiquidGoalIds(recordId);
    setLiquidModuleToUpdate(moduleData);
  };

  const handleRetirementAssetChange = (rows) => {
    // Update local tab state
    setTabRows((prevTabRows) => ({
      ...prevTabRows,
      "ASSIGN ASSET": rows,
    }));

    if (Array.isArray(rows)) {
      const assetId = rows.map((item) => item.assetId || item.id);
      const Strategy = rows.map((item) => item.Strategy);
      const annualSavings = rows.map((item) => item.annualSavings);
      const savings_override = rows.map((item) => item.savings_override);
      const rateOfReturn = rows.map((item) => item.rateOfReturn);
      const saleYear = rows.map((item) => item.saleYear);
      const costToSell = rows.map((item) => item.costToSell);
      const futureValue = rows.map((item) => item.futureValue);
      const netLumpSum = rows.map((item) => item.netLumpSum);
      const listType = rows.map((item) => item.listType);
      const amountUseForGoal = rows.map((item) => item.amountUseForGoal);
      const taxStatusArray = rows.map((item) => item.taxStatus);

      // Aggregates for RetirementProjection
      let taxableBalance = 0;
      let taxDeferredBalance = 0;
      let taxFreeBalance = 0;
      let taxableContrib = 0;
      let taxDeferredContrib = 0;
      let taxFreeContrib = 0;

      rows.forEach((row) => {
        const bal = parseFloat(row.valueOfAssetGoalRate) || 0;
        const contrib = parseFloat(row.annualSavings) || 0;
        const status = row.taxStatus || "";

        if (status === "Roth IRA (Tax-Free)") {
          taxFreeBalance += bal;
          taxFreeContrib += contrib;
        } else if (status === "Tax-Deferred 401k") {
          taxDeferredBalance += bal;
          taxDeferredContrib += contrib;
        } else {
          taxableBalance += bal;
          taxableContrib += contrib;
        }
      });

      setPayload((prevValue) => ({
        ...prevValue,
        assetId: assetId,
        Strategy: Strategy,
        annualSavings: annualSavings,
        savings_override: savings_override,
        rateOfReturn: rateOfReturn,
        saleYear: saleYear,
        costToSell: costToSell,
        futureValue: futureValue,
        netLumpSum: netLumpSum,
        listType: listType,
        amountUseForGoal: amountUseForGoal,
        taxStatus: taxStatusArray,
        taxableBalance,
        taxDeferredBalance,
        taxDeferredYearEndBalance: taxDeferredBalance,
        taxFreeBalance,
        taxableContrib,
        taxDeferredContrib,
        taxFreeContrib,
      }));
    }
  };

  const handleFormInputChange = (title, rows) => {
    setTabRows((prevTabRows) => ({
      ...prevTabRows,
      [activeTabName]: rows,
    }));

    setPayload((prevValue) => {
      // Create a new payload object based on the previous state
      const updatedPayload = { ...prevValue };

      // Extract field names dynamically from rows
      // if (rows.length === 0) {
      //   Object.keys(updatedPayload).forEach((key) => {
      //     delete updatedPayload[key];
      //   });
      //   return updatedPayload;
      // }
      // this is for deleting rows
      const activeTabRows = tabRows[activeTabName] || [];

      // Iterate over each row in the active tab rows
      activeTabRows.forEach((row) => {
        Object.keys(row).forEach((key) => {
          if (key !== "key") {
            // If the key exists in the payload, remove it
            if (updatedPayload[key]) {
              delete updatedPayload[key];
            }
          }
        });
      });
      const areAllRowsEmpty = rows.every((row) =>
        Object.keys(row).every((key) => key === "key" || row[key] === null),
      );
      // console.log("activeTabName44",activeTabName,activeTabRows)

      // this is for end deleting rows
      const fields = new Set();
      rows.forEach((row) => {
        Object.keys(row).forEach((key) => {
          if (key !== "key") {
            // Exclude the 'key' property
            fields.add(key);
          }
        });
      });

      // Initialize arrays for each field in the payload
      fields.forEach((field) => {
        updatedPayload[field] = [];
      });

      // Iterate over each row
      rows.forEach((row, index) => {
        // Check if the row is completely null or empty
        const isRowEmpty = Object.keys(row).every(
          (key) => key === "key" || row[key] === null,
        );
        if (!isRowEmpty) {
          // Iterate over each key-value pair in the row
          Object.keys(row).forEach((key) => {
            if (key !== "key") {
              // Exclude the 'key' property from the payload
              // Ensure the key exists in the payload object
              if (!updatedPayload[key]) {
                updatedPayload[key] = [];
              }

              // Add or replace the value at the corresponding index
              const index = parseInt(row.key, 10) - 1; // Assuming 'key' is 1-based index

              // Ensure the array is long enough
              if (index >= updatedPayload[key].length) {
                updatedPayload[key].length = index + 1;
              }

              // Update the value at the specific index
              updatedPayload[key][index] = row[key];
            }
          });
        }
      });

      // Remove trailing empty/null values in each field array
      Object.keys(updatedPayload).forEach((field) => {
        if (Array.isArray(updatedPayload[field])) {
          updatedPayload[field] = updatedPayload[field].filter(
            (value) => value !== null,
          );
        }
      });
      if (
        areAllRowsEmpty &&
        activeTabName === "ASSISTANCE FROM FRIENDS AND FAMILY"
      ) {
        // If all rows are empty, initialize payload keys with empty arrays
        updatedPayload["Date"] = [null];
        updatedPayload["Person Providing Assistance"] = [null];
        updatedPayload["Relationship"] = [null];
        updatedPayload["Amount Received"] = [null];
        // return updatedPayload; // Exit early if all rows are empty
      }
      return updatedPayload;
    });
  };
  const deleteAssignAsset = async (record) => {
    deleteAsset(record);
    // try {
    //   // setLoading(true);
    //   const userToken = localStorage.getItem("userLoginToken");
    //   const baseUrl="http://192.168.100.4:3000";
    //   const response = await axios.post(
    //     `${baseUrl}/goal/remove_assigned_asset`,
    //     {
    //       goalId:id,
    //       assetId:record.asset_id,
    //     },
    //     {
    //       headers: {
    //         Authorization: `Bearer ${userToken}`,
    //       },
    //     }
    //   );
    //   console.log("response",response);
    //   // setLoading(false);
    // } catch (error) {
    //   // setLoading(false);

    //   console.error("Error fetching user data:", error);
    // }
  };
  // const handleFormInputChange = (title, rows) => {
  //   console.log("rows", rows);
  //   setTabRows((prevTabRows) => ({
  //     ...prevTabRows,
  //     [activeTabName]: rows,
  //   }));
  //   setPayload(prevValue => {
  //     // Create a new payload object based on the previous state
  //     const updatedPayload = { ...prevValue };

  //     // Extract field names dynamically from rows
  //     const fields = new Set();
  //     rows.forEach(row => {
  //       Object.keys(row).forEach(key => {
  //         if (key !== "key") { // Exclude the 'key' property
  //           fields.add(key);
  //         }
  //       });
  //     });

  //     // Initialize arrays for each field in the payload
  //     fields.forEach(field => {
  //       updatedPayload[field] = [];
  //     });

  //     // Iterate over each row
  //     rows.forEach(row => {
  //       // Iterate over each key-value pair in the row
  //       Object.keys(row).forEach(key => {
  //         if (key !== "key") { // Exclude the 'key' property from the payload
  //           // Ensure the key exists in the payload object
  //           if (!updatedPayload[key]) {
  //             updatedPayload[key] = [];
  //           }

  //           // Add or replace the value at the corresponding index
  //           const index = parseInt(row.key, 10) - 1; // Assuming 'key' is 1-based index

  //           // Ensure the array is long enough
  //           if (index >= updatedPayload[key].length) {
  //             updatedPayload[key].length = index + 1;
  //           }

  //           // Update the value at the specific index
  //           updatedPayload[key][index] = row[key];
  //         }
  //       });
  //     });

  //     return updatedPayload;
  //   });
  // };
  const convertPayloadToRows = (payload) => {
    // Get the field names from the payload, excluding the fields that are arrays
    const fields = Object.keys(payload).filter((key) =>
      Array.isArray(payload[key]),
    );

    // Determine the number of rows based on the length of the arrays in the payload
    const numberOfRows = Math.max(
      ...fields.map((field) => payload[field].length),
    );

    // Create the rows array
    const rows = Array.from({ length: numberOfRows }, (_, index) => {
      const row = { key: (index + 1).toString() };

      // Populate each row with data from the payload
      fields.forEach((field) => {
        row[field] = payload[field][index] || ""; // Use empty string if value is undefined
      });

      return row;
    });
    setTabRows((prevTabRows) => ({
      ...prevTabRows,
      [activeTabName]: rows,
    }));
    return rows;
  };
  // const rows = convertPayloadToRows(payload);

  const childExclusiveFields = [
    "Natural: $10,000 to $15,000",
    "Adoption: $8,000 to $40,000",
    "Fertility: $22,000 to $75,000",
  ];
  const investmentNeedFields = ["Loan Amount", "Repair Costs"];
  const retirementBudgetFields = [
    "Housing (Taxes, Insurance, Upkeep)",
    "Healthcare (Premiums, Out-of-Pocket)",
    "Travel & Leisure",
    "Daily Living (Food, Utilities, etc.)",
    "Other Expenses",
  ];
  // const isOtherExclusiveFieldFilled = (currentField) => {
  //   if (!childExclusiveFields.includes(currentField)) return false;

  //   return childExclusiveFields.some(
  //     (field) =>
  //       field !== currentField &&
  //       (payload[field] || payload[field] === 0 || attributeValues[field])
  //   );
  // };

  const isOtherExclusiveFieldFilled = (currentField) => {
    if (!childExclusiveFields.includes(currentField)) return false;

    return childExclusiveFields.some((field) => {
      if (field === currentField) return false;
      const liveValue = payload[field];
      const initialValue = attributeValues[field];
      return liveValue !== undefined
        ? liveValue || liveValue === 0
        : initialValue || initialValue === 0;
    });
  };
  const disabledAttributes = [
    "Monthly Savings Required (at 0% RoR)",
    "Asset to Save to",
    "Monthly Savings with Rate of Return",
    "New Need Amount",
    "Percent Funded",
    "Current Monthly Saving Capacity (Based on Last Month)",
    "Total Monthly Saving for All Goals",
    "Housing Difference %",
    "Housing Difference $",
    "Groceries Difference %",
    "Groceries Difference $",
    "Utilities Difference %",
    "Utilities Difference $",
    "Transportation Difference %",
    "Transportation Difference $",
    "Salary Difference %",
    "Salary Difference $",
    "Net Annual Post-Retirement Budget",
    "Total Annual Retirement Income",
    "Net Amount Needed in Future with Inflation"
  ];

  useEffect(() => {
    if (payload["Amount Received"] || assetsAssign) {
      calculateLoanForGoal();
    }
  }, [
    payload["Amount Received"],
    payload["Total Monthly Saving for All Goals"],
    assetsAssign,
  ]);
  useEffect(() => {
    if (
      payload["Your Estimated Social Security"] ||
      payload["Annual Amount"] ||
      payload["Part-time Work During Retirement"]
    ) {
      const socialSecurity = Number(
        payload["Your Estimated Social Security"] || 0,
      );
      const partTimeWorking = Number(
        payload["Part-time Work During Retirement"] || 0,
      );
      const annualIncome =
        payload["Annual Amount"] && Array.isArray(payload["Annual Amount"])
          ? payload["Annual Amount"].reduce((acc, curr) => acc + +curr, 0)
          : 0;
      const totalIncome = socialSecurity + partTimeWorking + annualIncome;
      console.log(
        "totalIncome",
        totalIncome,
        socialSecurity,
        partTimeWorking,
        annualIncome,
      );
      setPayload((prevValue) => {
        const updatedPayload = {
          ...prevValue,
          "Total Annual Retirement Income": totalIncome,
        };

        // 🛑 Prevent infinite loop by only updating if something changed
        const isSame = Object.keys(updatedPayload).every(
          (key) => updatedPayload[key] === prevValue[key],
        );

        return isSame ? prevValue : updatedPayload;
      });
    }
  }, [
    payload["Your Estimated Social Security"],
    payload["Annual Amount"],
    payload["Part-time Work During Retirement"],
  ]);

  useEffect(() => {
    if (
      module === "Retirement" &&
      (payload["Net Annual Post-Retirement Budget"] ||
        payload["Inflation rate for this goal"] ||
        payload["Desired Retirement Age"] ||
        payload["Current Age"])
    ) {
      calculateRetirementNeed();
    }
  }, [
    module,
    payload["Net Annual Post-Retirement Budget"],
    payload["Inflation rate for this goal"],
    payload["Desired Retirement Age"],
    payload["Current Age"],
    taxInfo,
  ]);

  useEffect(() => {
    if (
      Array.isArray(assetsToselect) &&
      payload &&
      (payload["Asset to Save to"] !== undefined ||
        payload["Would you like to apply savings to a goal?"])
    ) {
      const selectedAsset =
        assetsToselect &&
        assetsToselect.find(
          (asset) => asset.id === Number(payload["Asset to Save to"]),
        );

      const response = calculateSavingsForGoal(payload, selectedAsset, taxInfo);

      setPayload((prevValue) => {
        const updatedPayload = {
          ...prevValue,
          "Monthly Savings with Rate of Return":
            parseFloat(response.monthlySavingRequired).toFixed(2) || 0,
          "Monthly Savings Required (at 0% RoR)":
            parseFloat(response.monthlySavingwithZeroRateofReturn).toFixed(2) ||
            0,
          "Current Monthly Saving Capacity (Based on Last Month)":
            parseFloat(response.actualMonthlySaving).toFixed(2) || 0,
          "Total Monthly Saving for All Goals":
            parseFloat(response.futureMonthlySaving).toFixed(2) || 0,
          totalhaveTillGoalDate: response.totalhaveTillGoalDate || 0,
          "New Need Amount": parseFloat(response.newTotalNeed).toFixed(2) || 0,
          "Percent Funded":
            parseFloat(response.percentageFunded).toFixed(2) || 0,
        };

        // 🛑 Prevent infinite loop by only updating if something changed
        const isSame = Object.keys(updatedPayload).every(
          (key) => updatedPayload[key] === prevValue[key],
        );

        return isSame ? prevValue : updatedPayload;
      });
    }
  }, [payload, assetsToselect]);

  const calculateLoanForGoal = () => {
    let totalAmountAssigned = 0;
    let totalLoanTaken = 0;
    // Calculate total amount assigned
    totalAmountAssigned =
      (payload["Amount Received"] && Array.isArray(payload["Amount Received"])
        ? payload["Amount Received"].reduce((acc, curr) => acc + +curr, 0)
        : 0) +
      (payload["Total Monthly Saving for All Goals"]
        ? parseFloat(payload["Total Monthly Saving for All Goals"])
        : 0) +
      (assetsAssign && Array.isArray(assetsAssign)
        ? assetsAssign.reduce(
            (acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0),
            0,
          )
        : 0);
    // Calculate totalLoanTaken as the difference between Goal need and total amount assigned
    totalLoanTaken =
      parseFloat(payload["Amount Needed in Future with Inflation"] || 0) -
      totalAmountAssigned;
    if (payload && payload["Will you need a loan for this goal?"] === true) {
      setPayload((prevValue) => {
        return {
          ...prevValue,
          ["Total Loan assigned to goal"]:
            +totalLoanTaken > 0 ? +parseFloat(totalLoanTaken).toFixed(2) : 0,
        };
      });
    }
    return +totalLoanTaken > 0 ? +parseFloat(totalLoanTaken).toFixed(2) : 0;
  };

  const calculateRetirementNeed = () => {
    const currentBudget = parseFloat(
      payload["Net Annual Post-Retirement Budget"] || 0,
    );

    let inflationRate = 0;
    const inflationInput = payload["Inflation rate for this goal"];
    const matchedInflation =
      taxInfo && taxInfo.find((item) => item.name === inflationInput);
    if (matchedInflation) {
      inflationRate = (parseFloat(matchedInflation.value) || 0) / 100;
    } else {
      const inflationRateStr = String(inflationInput || "0");
      const parsedRate = parseFloat(inflationRateStr.replace(/[^0-9.]/g, ""));
      inflationRate = (isNaN(parsedRate) ? 0 : parsedRate) / 100;
    }

    const desiredRetAge = parseFloat(payload["Desired Retirement Age"] || 0);
    const currentAge = parseFloat(payload["Current Age"] || 0);
    let yearsToRetirement = desiredRetAge - currentAge;

    if (!yearsToRetirement || yearsToRetirement < 0) yearsToRetirement = 0;

    const futureAnnualSpend =
      currentBudget * Math.pow(1 + inflationRate, yearsToRetirement);

    const updatedValue = parseFloat(futureAnnualSpend).toFixed(2);

    setPayload((prevValue) => {
      if (
        prevValue["Net Amount Needed in Future with Inflation"] === updatedValue
      ) {
        return prevValue;
      }
      return {
        ...prevValue,
        ["Net Amount Needed in Future with Inflation"]: updatedValue,
      };
    });

    setAttributeValues((prevValue) => {
      if (
        prevValue["Net Amount Needed in Future with Inflation"] === updatedValue
      ) {
        return prevValue;
      }
      return {
        ...prevValue,
        ["Net Amount Needed in Future with Inflation"]: updatedValue,
      };
    });

    return updatedValue;
  };


  const handleInputFields = (inputName, value) => {
    // setPayload((prevValue) => ({ ...prevValue, [inputName]: value }));
    setPayload((prevValue) => {
      if (
        inputName === "Will you need a loan for this goal?" &&
        value === true
      ) {
        return {
          ...prevValue,
          [inputName]: value,
          "Total Loan assigned to goal": calculateLoanForGoal(),
        };
      }
      // If inputName is one of the child-exclusive fields
      if (childExclusiveFields.includes(inputName)) {
        return {
          ...prevValue,
          [inputName]: value,
          "Dollar Amount Needed": value, // Set same value here
        };
      }
      if (investmentNeedFields.includes(inputName)) {
        const updatedValues = {
          ...prevValue,
          [inputName]: value,
        };
        const loanAmount = Number(updatedValues["Loan Amount"] || 0);
        const repairCosts = Number(updatedValues["Repair Costs"] || 0);
        const totalNeeded = loanAmount + repairCosts;
        return {
          ...updatedValues,
          "Dollar Amount Needed": totalNeeded,
        };
      }

      if (retirementBudgetFields.includes(inputName)) {
        const updatedValues = {
          ...prevValue,
          [inputName]: value,
        };
        const housing = Number(
          updatedValues["Housing (Taxes, Insurance, Upkeep)"] || 0,
        );
        const healthcare = Number(
          updatedValues["Healthcare (Premiums, Out-of-Pocket)"] || 0,
        );
        const travel = Number(updatedValues["Travel & Leisure"] || 0);
        const dailyLiving = Number(
          updatedValues["Daily Living (Food, Utilities, etc.)"] || 0,
        );
        const otherExpenses = Number(updatedValues["Other Expenses"] || 0);

        const totalBudget =
          housing + healthcare + travel + dailyLiving + otherExpenses;

        return {
          ...updatedValues,
          "Net Annual Post-Retirement Budget": totalBudget,
        };
      }
      // Otherwise, just update the payload with the inputName and value
      return {
        ...prevValue,
        [inputName]: value,
      };
    });
    // --- Update attributeValues with same logic ---
    setAttributeValues((prevValues) => {
      let updatedAttr = { ...prevValues, [inputName]: value };

      if (
        inputName === "Will you need a loan for this goal?" &&
        value === true
      ) {
        updatedAttr["Total Loan assigned to goal"] = calculateLoanForGoal();
      }

      if (childExclusiveFields.includes(inputName)) {
        updatedAttr["Dollar Amount Needed"] = value;
      }

      if (investmentNeedFields.includes(inputName)) {
        const loanAmount = Number(updatedAttr["Loan Amount"] || 0);
        const repairCosts = Number(updatedAttr["Repair Costs"] || 0);
        updatedAttr["Dollar Amount Needed"] = loanAmount + repairCosts;
      }

      if (retirementBudgetFields.includes(inputName)) {
        const housing = Number(
          updatedAttr["Housing (Taxes, Insurance, Upkeep)"] || 0,
        );
        const healthcare = Number(
          updatedAttr["Healthcare (Premiums, Out-of-Pocket)"] || 0,
        );
        const travel = Number(updatedAttr["Travel & Leisure"] || 0);
        const dailyLiving = Number(
          updatedAttr["Daily Living (Food, Utilities, etc.)"] || 0,
        );
        const otherExpenses = Number(updatedAttr["Other Expenses"] || 0);

        updatedAttr["Net Annual Post-Retirement Budget"] =
          housing + healthcare + travel + dailyLiving + otherExpenses;
      }

      return updatedAttr;
    });
  };
  const handleFileChange = async (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      if (e.target.files) {
        setIsLoading(true);
        let uploadedFile = e.target.files[0];
        const formData = new FormData();
        formData.append("file", uploadedFile);
        const name = uploadedFile.name;
        const lastDot = name.lastIndexOf(".");
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        const resdata = await MODULE_API.uploadFile({
          fileExt: ext,
          contentType: uploadedFile.type,
        });
        const resupload = await axios.put(resdata.uploadUrl, uploadedFile, {
          headers: { "Content-type": uploadedFile.type },
        });
        setIsLoading(false);
        const imgUrl = resdata.uploadUrl.split("?")[0];
        return imgUrl;
      }
    } catch (e) {
      console.log("error", e);
      swal("Error!", "File Size Too Big!", "error");
      setIsLoading(false);
    }
  };
  const extractFileNameFromUrl = (url) => {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1]; // Get the last part of the URL, which is the file name
  };

  const DynamicComponentGenerator = (item) => {
    if (data[item]) {
      if (data[item].formGroupName) {
        return <React.Fragment></React.Fragment>;
      } else {
        return SubFieldGenerator(data[item]);
      }
    }
  };
  const dependentAttributes = [
    "Are you getting financial assistance?",
    "Are you getting Financial Assistance From Friend or Family?",
    "Would You Like to Assign an Asset to the Goal?",
    "Would you like to apply savings to a goal?",
    "Will you need a loan for this goal?",
    "Complete Details Now or later?",
    "Would you like to apply student loan to goal?",
    "Are you getting Scholarship or Grant?",
    "Do you add work study?",
    "What Type of Personal Loan is this?",
    "Taxes",
    "Utilities",
    "Simple and Advanced",
  ];
  const dependentInputFields = [
    "Total Loan assigned to goal",
    "Loan Interest Rate",
    "Loan End Date",
    "Depreciation Module [Not Built Yet]",
    "Local",
    "State",
    "Federal",
    "Telecom",
    "Electricity",
    "Water",
    "Waste",
    "Gas",
    "Other Utilities",
    "Net Annual Post-Retirement Budget",
    "Inflation rate for this goal",
    "Net Amount Needed in Future with Inflation",
    "Housing (Taxes, Insurance, Upkeep)",
    "Healthcare (Premiums, Out-of-Pocket)",
    "Travel & Leisure",
    "Daily Living (Food, Utilities, etc.)",
    "Other Expenses",
    "assetId",
    "Strategy",
    "annualSavings",
    "rateOfReturn",
    "savings_override",
    "saleYear",
    "costToSell",
    "futureValue",
    "netLumpSum",
    "listType",
    "amountUseForGoal",
    "taxStatus",
  ];
  const isDependentAttributeTrue = (dependentAttributes, payload) => {
    const inputFieldIds =
      inputFields && inputFields.map((id) => parseInt(id, 10));
    const filteredAttributes =
      attributes &&
      attributes.filter((attr) => inputFieldIds.includes(attr.id));
    const hasAttributesWithoutFormGroupName = filteredAttributes.every(
      (attr) => attr.formGroupName !== null,
    );
    // console.log("hasAttributesWithoutFormGroupName",hasAttributesWithoutFormGroupName)
    if (hasAttributesWithoutFormGroupName) {
      return true;
    }
    return filteredAttributes.some(
      (attr) =>
        (dependentAttributes.includes(attr.name) &&
          payload[attr.name] === true) ||
        (attr.name === "What Type of Personal Loan is this?" &&
          payload[attr.name] !== null) ||
        (attr.name === "Simple and Advanced" &&
          (payload[attr.name] === "Simple" ||
            payload[attr.name] === "Advanced" ||
            attributeValues[attr.name] === "Simple" ||
            attributeValues[attr.name] === "Advanced")),
    );
  };
  const isDependentInputField = (
    dependentAttributes,
    dependentInputFields,
    payload,
    inputName,
  ) => {
    const inputFieldIds =
      inputFields && inputFields.map((id) => parseInt(id, 10));
    const filteredAttributes =
      attributes &&
      attributes.filter((attr) => inputFieldIds.includes(attr.id));
    // Check if the inputName is in dependentInputFields
    const isInputDependent = dependentInputFields.includes(inputName);
    // If inputName is not in dependentInputFields, return true
    if (!isInputDependent) {
      return true;
    }

    const simpleFields = [
      "Net Annual Post-Retirement Budget",
      "Inflation rate for this goal",
      "Net Amount Needed in Future with Inflation",
    ];
    const advancedOnlyFields = [
      "Housing (Taxes, Insurance, Upkeep)",
      "Healthcare (Premiums, Out-of-Pocket)",
      "Travel & Leisure",
      "Daily Living (Food, Utilities, etc.)",
      "Other Expenses",
    ];

    if (simpleFields.includes(inputName)) {
      return (
        payload["Simple and Advanced"] === "Simple" ||
        payload["Simple and Advanced"] === "Advanced" ||
        attributeValues["Simple and Advanced"] === "Simple" ||
        attributeValues["Simple and Advanced"] === "Advanced"
      );
    }

    if (advancedOnlyFields.includes(inputName)) {
      return (
        payload["Simple and Advanced"] === "Advanced" ||
        attributeValues["Simple and Advanced"] === "Advanced"
      );
    }
    // Otherwise, check if any of the filtered attributes match dependent attributes or inputName
    return filteredAttributes.some(
      (attr) =>
        (dependentAttributes.includes(attr.name) &&
          payload[attr.name] === true) ||
        (dependentInputFields.includes(attr.name) &&
          payload[attr.name] === true) ||
        (attr.name === inputName && payload[attr.name] === true),
    );
  };

  //   const isDependentInputField = (dependentAttributes, dependentInputFields, payload, inputName) => {
  //     const inputFieldIds = inputFields && inputFields.map((id) => parseInt(id, 10));
  //     const filteredAttributes = attributes && attributes.filter((attr) => inputFieldIds.includes(attr.id));

  //     // Check if any attribute is not in dependentInputFields
  //     const hasNonDependentInputField = filteredAttributes.every(attr => !dependentInputFields.includes(attr.name));
  //     console.log("hasNonDependentInputField",hasNonDependentInputField,filteredAttributes)
  //     // Return true if there are non-dependent input fields
  //     if (hasNonDependentInputField) {
  //         return true;
  //     }

  //     // Otherwise, check if any of the filtered attributes match dependent attributes or inputName
  //     return filteredAttributes.some(attr =>
  //         (dependentAttributes.includes(attr.name) && payload[attr.name] === true) ||
  //         (dependentInputFields.includes(attr.name) && payload[attr.name] === true) ||
  //         (attr.name === inputName && payload[attr.name] === true)
  //     );
  // };
  const assignGoalColumns = [
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      fields: [
        {
          type: "string",
          name: "priority",
        },
      ],
    },
    {
      title: "Asset",
      dataIndex: "asset",
      key: "asset",
      fields: [
        {
          type: "string",
          name: "asset",
        },
      ],
    },
    ...(module === "Retirement"
      ? [
          {
            title: "Strategy",
            dataIndex: "Strategy",
            key: "Strategy",
            fields: [
              {
                type: "string",
                name: "Strategy",
              },
            ],
          },
          {
            title: "Annual Savings",
            dataIndex: "annualSavings",
            key: "annualSavings",
            fields: [
              {
                type: "float",
                name: "annualSavings",
              },
            ],
          },
          {
            title: "Return Rate",
            dataIndex: "rateOfReturn",
            key: "rateOfReturn",
            fields: [
              {
                type: "float",
                name: "rateOfReturn",
              },
            ],
          },
        ]
      : []),
    {
      title: "Value of Asset at goal date",
      dataIndex: "valueOfAssetGoalRate",
      key: "valueOfAssetGoalRate",
      fields: [
        {
          type: "float",
          name: "valueOfAssetGoalRate",
        },
      ],
    },
    {
      title: "Loan value to goal date",
      dataIndex: "loanValueGoalDate",
      key: "loanValueGoalDate",
      fields: [
        {
          type: "float",
          name: "loanValueGoalDate",
        },
      ],
    },
    {
      title: "Amount to use for this goal",
      dataIndex: "amountUseForGoal",
      key: "amountUseForGoal",
      fields: [
        {
          type: "float",
          name: "amountUseForGoal",
        },
      ],
    },
    {
      title: "Amount used in other goal",
      dataIndex: "Amount used in other goal",
      key: "Amount used in other goal",
      fields: [
        {
          type: "float",
          name: "Amount used in other goal",
        },
      ],
    },
    {
      title: "Taxes",
      dataIndex: "taxes",
      key: "taxes",
      fields: [
        {
          type: "float",
          name: "taxes",
        },
      ],
    },
    {
      title: "Net after tax applied to goals",
      dataIndex: "netAmountAfterTax",
      key: "netAmountAfterTax",
      fields: [
        {
          type: "float",
          name: "netAmountAfterTax",
        },
      ],
    },
    {
      title: "asset_id",
      dataIndex: "assetId",
      key: "assetId",
      fields: [
        {
          type: "int",
          name: "assetId",
        },
      ],
    },
    {
      title: "goal_status",
      dataIndex: "goal_status",
      key: "goal_status",
      fields: [
        {
          type: "string",
          name: "goal_status",
        },
      ],
    },
  ];
  const SubFieldGenerator = (item) => {
    const { view } = useParams();
    switch (item.dataType) {
      case "boolean":
        return (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
              <Radio.Group
                disabled={view}
                style={{ marginTop: "0.5rem" }}
                value={
                  payload[item.name] && payload[item.name] === true
                    ? true
                    : false
                }
                // defaultChecked={payload[item.name] ? payload[item.name] :null }
                onChange={(e) => {
                  handleInputFields(item.name, e.target.value);
                }}
                size="large"
              >
                <Radio.Button value={true} style={{ marginRight: "0.5rem" }}>
                  Yes
                </Radio.Button>
                <Radio.Button value={false} style={{ marginRight: "0.5rem" }}>
                  No
                </Radio.Button>
              </Radio.Group>
            </label>
          </Styles.SubFormDiv>
        );
      case "string":
        return (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem", 
            display:["assetId",
                    "Strategy",
                    "saleYear",
                    "listType",].includes(item.name) ? "none" : ""
                   }}>
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
            </label>
            <Styles.InputBorder>
              <input
                type="text"
                placeholder={item.placeHolder ? item.placeHolder : item.name}
                disabled={view}
                readOnly={view}
                style={{
                  outline: "none",
                  border: "none",
                  width: "98%",
                  // marginTop:"0.5rem"
                }}
                value={
                  payload[item.name]
                    ? payload[item.name]
                    : attributeValues[item.name]
                      ? attributeValues[item.name]
                      : ""
                }
                onChange={(e) => {
                  handleInputFields(item.name, e.target.value);
                }}
              />
            </Styles.InputBorder>
          </Styles.SubFormDiv>
        );
      case "image":
        return (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
            </label>
            <Styles.InputBorder
              style={{
                alignItems: "center",
                background: "white",
                paddingInline: "1rem",
                display: "flex",
                justifyContent: "space-between",
                cursor: view ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (!view) {
                  const inputEl = document.getElementById(item.name);
                  if (inputEl) inputEl.click();
                }
              }}
            >
              {/* Hidden file input */}
              <input
                id={item.name}
                type="file"
                disabled={view}
                style={{ display: "none" }}
                onChange={async (e) => {
                  const res = await handleFileChange(e);
                  handleInputFields(item.name, res);
                }}
              />

              {/* Label that displays status */}
              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                  cursor: view ? "not-allowed" : "pointer",
                }}
              >
                {isLoading ? (
                  <Spin />
                ) : payload[item.name] || attributeValues[item.name] ? (
                  <a
                    href={payload[item.name] || attributeValues[item.name]}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "underline",
                      color: "#2A3DA3",
                      maxWidth: "200px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    onClick={(e) => e.stopPropagation()} // prevent InputBorder click triggering input again
                  >
                    {extractFileNameFromUrl(
                      payload[item.name] || attributeValues[item.name],
                    )}
                  </a>
                ) : (
                  <span style={{ color: "#999" }}>Choose file</span>
                )}

                <Icon
                  className=""
                  style={{
                    fontSize: "23px",
                    background: "#2A3DA3",
                    padding: "8px",
                    borderRadius: "5px",
                    color: "white",
                  }}
                  type="upload"
                />
              </div>
            </Styles.InputBorder>
          </Styles.SubFormDiv>
        );
      case "int":
        return (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem",display:["assetId",
                    "Strategy",
                    "saleYear",
                    "listType",].includes(item.name) ? "none" : ""
                   }}>
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
            </label>
            <Styles.InputBorder style={{ width: "97%" }}>
              <input
                type="text"
                readOnly={view}
                placeholder={item.placeHolder ? item.placeHolder : item.name}
                style={{
                  outline: "none",
                  border: "none",
                  width: "98%",
                  // marginTop:"0.5rem"
                }}
                value={
                  payload[item.name]
                    ? payload[item.name]
                    : attributeValues[item.name]
                      ? attributeValues[item.name]
                      : ""
                }
                onChange={(e) => {
                  const result = e.target.value.replace(/\D/g, "");
                  handleInputFields(item.name, result);
                }}
              />
            </Styles.InputBorder>
          </Styles.SubFormDiv>
        );
      case "float":
        return (
          isDependentInputField(
            dependentAttributes,
            dependentInputFields,
            payload,
            item.name,
          ) && (
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
                display:
                  (module === "Add Child" ||
                    module === "Investment Property") &&
                  item.name === "Dollar Amount Needed" &&
                  "none",
              }}
            >
              <label style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  {item.name}
                  {item &&
                    item.name &&
                    [
                      "Total Loan assigned to goal",
                      "Current Monthly Gap",
                      "Suggested Savings",
                      "Your Commitment",
                      "Remaining Monthly Gap",
                      "Funds Last Until Age",
                      "Target Account",
                    ].includes(item.name) && (
                      <ToolTipCreator
                        name={
                          item.name === "Total Loan assigned to goal"
                            ? "Goals_Total_Loan_Assigned_to_Goal"
                            : item.name
                        }
                      />
                    )}
                </div>
              </label>
              <Styles.InputBorder
                style={{
                  paddingLeft: "0px",
                  position: "relative",
                  width: "97%",
                }}
              >
                {item &&
                  item.name &&
                  ![
                    "Loan Interest Rate",
                    "Percent Funded",
                    "Funds Last Until Age",
                    "Interest Rate",
                    "Vacancy Rate (%)",
                    "% Difference",
                  ].includes(item.name) &&
                  !item.name.includes("%") && (
                    <span className="dollarSymbol">$</span>
                  )}
                {/* Placeholder Text */}
                {!(
                  payload[item.name] ||
                  attributeValues[item.name] ||
                  payload[item.name] === 0 ||
                  attributeValues[item.name] === 0 ||
                  payload[item.name] === "" ||
                  payload[item.name] === "0.00" ||
                  attributeValues[item.name] === "0.00" ||
                  !payload[item.name] ||
                  item.name ===
                    "Current Monthly Saving Capacity (Based on Last Month)" ||
                  item.name === "Total Monthly Saving for All Goals"
                ) && (
                  <span className="inputNumberPlaceholder">
                    {item.placeHolder ? item.placeHolder : item.name}
                  </span>
                )}
                <InputNumber
                  disabled={
                    view ||
                    isOtherExclusiveFieldFilled(item.name) ||
                    (item.name === "Net Annual Post-Retirement Budget"
                      ? payload["Simple and Advanced"] === "Advanced" ||
                        attributeValues["Simple and Advanced"] === "Advanced"
                      : disabledAttributes.some((attr) =>
                          item.name.includes(attr),
                        ))
                  }
                  style={{
                    outline: "none",
                    border: "none",
                    width: "92%",
                    height: "3.5rem",
                  }}
                  className="Input"
                  precision={2}
                  step={1}
                  formatter={(value) =>
                    value && `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                  name={item.name}
                  // value={
                  //   payload[item.name]
                  //     ? payload[item.name]
                  //     : attributeValues[item.name]
                  //     ? attributeValues[item.name]
                  //     : ""
                  // }
                  value={getInputValue(item.name)}
                  onChange={(value) => {
                    handleInputFields(item.name, value);
                  }}
                />
                {((item &&
                  item.name &&
                  [
                    "Loan Interest Rate",
                    "Percent Funded",
                    "Funds Last Until Age",
                    "Interest Rate",
                    "Vacancy Rate (%)",
                    "% Difference",
                  ].includes(item.name)) ||
                  item.name.includes("%")) && (
                  <span className="dollarSymbol">%</span>
                )}
              </Styles.InputBorder>
            </Styles.SubFormDiv>
          )
        );
      case "dropdown":
        return item.name && ["Asset to Save to"].includes(item.name) ? (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
            <label style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "baseline",
                  columnGap: "3px",
                }}
              >
                {item.name}{" "}
                {item &&
                  item.name &&
                  ["Target Account"].includes(item.name) && (
                    <ToolTipCreator name={item.name ? item.name : ""} />
                  )}
              </div>
            </label>
            <Select
              showSearch
              className="asset-dropdown"
              style={{ width: "12.5rem" }}
              placeholder="Select Asset"
              onPopupScroll={handlePopupScroll} // Pagination on scroll
              // value={payload && payload[item.name]}
              value={
                payload &&
                assetsToselect &&
                assetsToselect.find(
                  (asset) => asset.id === Number(payload[item.name]),
                )
                  ? assetsToselect &&
                    assetsToselect.find(
                      (asset) => asset.id === Number(payload[item.name]),
                    )["Name of Asset"]
                  : undefined
              }
              onChange={(value) => {
                const selectedAsset =
                  assetsToselect &&
                  assetsToselect.find((asset) => asset.id === value);
                setSelectedAssets(value);
                handleInputFields(item.name, value);
              }}
              notFoundContent={loadingAssets ? <Spin /> : null}
              optionLabelProp="label"
              dropdownStyle={{ minHeight: "3.5rem" }}
            >
              {assetsToselect &&
                assetsToselect.map((asset, index) => (
                  <Option
                    key={asset.id}
                    value={asset.id}
                    label={
                      asset["Name of Asset"] ||
                      asset["Nickname of Liabilities"] ||
                      asset["Nickname of Credit"]
                    }
                  >
                    <span
                      role="img"
                      aria-label={
                        asset["Name of Asset"] ||
                        asset["Nickname of Liabilities"] ||
                        asset["Nickname of Credit"]
                      }
                      style={{ marginRight: "8px" }}
                    >
                      <img
                        width={32}
                        src={asset.image}
                        alt={
                          asset["Name of Asset"] ||
                          asset["Nickname of Liabilities"] ||
                          asset["Nickname of Credit"]
                        }
                      ></img>
                    </span>
                    {asset["Name of Asset"] ||
                      asset["Nickname of Liabilities"] ||
                      asset["Nickname of Credit"]}
                  </Option>
                ))}
            </Select>
          </Styles.SubFormDiv>
        ) : (
          (module === "Retirement"
            ? isDependentInputField(
                dependentAttributes,
                dependentInputFields,
                payload,
                item.name,
              )
            : true) && (
            <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
              <label style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  {item.name}{" "}
                  {item &&
                    item.name &&
                    ["Target Account"].includes(item.name) && (
                      <ToolTipCreator name={item.name ? item.name : ""} />
                    )}
                </div>
              </label>
              {item.name !== "Payment Type" &&
              item.name !== "Simple and Advanced" ? (
                <DropDown
                  readOnly={view}
                  style={defaultStyles.styles.dropDown.m_smallDropdown1}
                  listingStyle={{
                    ...defaultStyles.styles.dropDown.m_smallDropdown2,
                    height: "auto",
                  }}
                  name={item.name}
                  title={item.name}
                  list={
                    item.attribute_default_values &&
                    item.attribute_default_values
                  }
                  displayKey="value"
                  disableSearch={false}
                  key={item.name}
                  value={payload && payload[item.name]}
                  defaultValue={payload && payload[item.name]}
                  placeholder={item.placeHolder ? item.placeHolder : item.name}
                  setSelectedItem={({ name, value }) => {
                    handleInputFields(name, value);
                  }}
                  // onChange={(e) => {
                  //   console.log("eeeeeee",e)
                  //   handleInputFields(item.name, e);
                  // }}
                  // options={
                  //   item.options &&
                  //   item.options.map((option) => ({
                  //     value: option.value,
                  //     label: option.value,
                  //   }))
                  // }
                />
              ) : (
                <Radio.Group
                  disabled={view}
                  style={{ marginTop: "0.5rem" }}
                  value={
                    payload[item.name]
                      ? payload[item.name]
                      : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                  }
                  onChange={(e) => {
                    handleInputFields(item.name, e.target.value);
                  }}
                  size="large"
                >
                  {item.attribute_default_values ? (
                    ([
                      "Replacement Cost or Cash Value",
                      "Short Term or Long Term",
                    ].includes(item.name)
                      ? [...item.attribute_default_values].reverse()
                      : item.attribute_default_values
                    ).map((att, index) => (
                      <Radio.Button
                        key={index}
                        value={att.value}
                        style={{ marginRight: "0.5rem" }}
                      >
                        {att.value}
                      </Radio.Button>
                    ))
                  ) : (
                    <React.Fragment>
                      <Radio.Button
                        value={true}
                        style={{ marginRight: "0.5rem" }}
                      >
                        Yes
                      </Radio.Button>
                      <Radio.Button
                        value={false}
                        style={{ marginRight: "0.5rem" }}
                      >
                        No
                      </Radio.Button>
                    </React.Fragment>
                  )}
                </Radio.Group>
              )}
            </Styles.SubFormDiv>
          )
        );
      case "checkbox":
        return (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
            </label>
            <Checkbox.Group
              disabled={view}
              style={{
                marginTop: "0.5rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "first baseline",
              }}
              value={(payload[item.name] || attributeValues[item.name] || "")
                .split("||")
                .filter((val) => val !== "")}
              onChange={(checkedValues) => {
                console.log("checkedValues", checkedValues);
                handleInputFields(item.name, checkedValues.join("||"));
              }}
            >
              {item.attribute_default_values ? (
                item.attribute_default_values.map((att, index) => (
                  <Checkbox
                    key={index}
                    value={att.value}
                    style={{
                      marginRight: "0.5rem",
                    }}
                  >
                    {att.value}
                  </Checkbox>
                ))
              ) : (
                <React.Fragment>
                  <Checkbox value="true" style={{ marginRight: "0.5rem" }}>
                    Yes
                  </Checkbox>
                  <Checkbox value="false" style={{ marginRight: "0.5rem" }}>
                    No
                  </Checkbox>
                </React.Fragment>
              )}
            </Checkbox.Group>
          </Styles.SubFormDiv>
        );
      case "date":
        return (
          isDependentInputField(
            dependentAttributes,
            dependentInputFields,
            payload,
            item.name,
          ) && (
            <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
              <label style={{ display: "flex", flexDirection: "column" }}>
                {item.name === "Goal Date" ? (
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        columnGap: "3px",
                      }}
                    >
                      {item.name}{" "}
                      {item &&
                        item.name &&
                        ["Goal Date"].includes(item.name) && (
                          <ToolTipCreator
                            name={
                              item.name === "Goal Date"
                                ? "Goals_Loan_End_Date"
                                : ""
                            }
                          />
                        )}
                    </div>
                    {item && item.name && item.name !== "Goal Date" && (
                      <img
                        style={{
                          cursor: "pointer",
                          height: "24px",
                          width: "24px",
                        }}
                        onClick={() => {
                          showTooltipModal();
                        }}
                        src={helpIcon}
                        alt="help"
                      />
                    )}
                    <Modal
                      centered
                      visible={tooltipModal}
                      footer={null}
                      onCancel={handleTooltipCancel}
                    >
                      <div className="modaltitle"> Goal Date</div>
                      <div style={{}}>
                        <div className="">
                          <div className="inputTitle">
                            Changing the Goal Date requires the recalculation of
                            the amount you need and the values of the Assets
                            that have been assigned to the Goal. Because of the
                            complexity of this, please remove the Assets that
                            have been assigned first, then adjust the Goal Date.
                          </div>
                        </div>
                      </div>
                    </Modal>
                  </div>
                ) : (
                  item.name
                )}
              </label>
              <Styles.InputBorder
                style={{
                  display: "flex",
                  alignItems: "center",
                  overflow: "hidden",
                }}
              >
                <DatePicker
                  // disabled={view}
                  disabled={
                    view ||
                    (payload["Goal Date"] &&
                      item.name === "Goal Date" &&
                      assetsAssign &&
                      assetsAssign.length > 0)
                      ? true
                      : false
                  }
                  format={"MM-DD-YYYY"}
                  style={{
                    outline: "none",
                    border: "none",
                    borderRadius: "0.5rem",
                  }}
                  key={item.name}
                  placeholder={item.placeHolder ? item.placeHolder : item.name}
                  value={
                    payload[item.name]
                      ? moment(payload[item.name])
                      : moment(attributeValues[item.name] || new Date())
                  }
                  // defaultValue={
                  //   values[item.name]
                  //     ? moment(values[item.name], item.format)
                  //     : ""
                  // }
                  onChange={(date, dateString) => {
                    handleInputFields(item.name, dateString);
                  }}
                />
              </Styles.InputBorder>
            </Styles.SubFormDiv>
          )
        );
      default:
        console.error("invalid DataType Detected :::: ", item.dataType);
        break;
        {
          /*  return (
          <Styles.SubFormDiv style={{ marginTop: "0.5rem" }}>
            <label style={{ display: "flex", flexDirection: "column" }}>
              {item.name}
              <Styles.Input
                key={item.name}
                placeholder={item.name}
                defaultValue={values[item.name]}
                onChange={(e) => handleInputFields(item.name, e.target.value)}
              />
            </label>
          </Styles.SubFormDiv>
        ); */
        }
    }
  };

  return (
    <React.Fragment>
      <div
        style={{
          textAlign: "left",
          margin: "0 3rem",
          fontFamily: "Poppins",
          fontWeight: "600",
          color: "#323a46",
          fontSize: "20px",
        }}
      >
        {activeTabName}
      </div>
      {activeTabName &&
        [
          "GOAL DETAILS",
          "COST OF LIVING ADJUSTMENT",
          "SALARY COMPARISON TOOL",
          "CHECKLIST",
          "PROPERTY INFORMATION",
          "ORIGINATION INFORMATION",
          "INVESTMENT INFORMATION",
          "MONTHLY OPERATING EXPENSES",
          "ASSISTANCE FROM FRIENDS AND FAMILY",
          "BIRTH",
          "PREPARING FOR THE NEW ARRIVAL",
          "BATH AND HEALTH",
          "TRAVEL AND TRANSPORTATION",
          "COSTS THROUGHTOUT YEAR",
          "ADDITIONAL COSTS THROUGHTOUT YEAR",
          "BOOKS, TOYS, ACTIVITIES",
          "ASSIGN ASSET",
          "DEDICATED SAVINGS & INVESTMENTS",
          "ADD SAVINGS",
          "ADD LOAN",
        ].includes(activeTabName) && (
          <React.Fragment>
            <div className="descriptionDisplay">
              {payload &&
                payload["Description of Goal"] &&
                payload["Description of Goal"]}
            </div>
            <div className="descriptionDisplay">
              {payload &&
                payload["Goal Date"] &&
                moment(payload["Goal Date"]).format("MMMM D, YYYY")}
            </div>
          </React.Fragment>
        )}
      {module === "Retirement" && (
        <RetirementSummary activeTabName={activeTabName} payload={payload} />
      )}
      {module === "Education" && (
        <EducationExpenseSummary
          activeTabName={activeTabName}
          payload={payload}
        />
      )}
      {module === "Add Child" ? (
        <ChildExpenseSummary activeTabName={activeTabName} payload={payload} />
      ) : (
        activeTabName &&
        [
          "COST OF LIVING ADJUSTMENT",
          "SALARY COMPARISON TOOL",
          "CHECKLIST",
          "PROPERTY INFORMATION",
          "ORIGINATION INFORMATION",
          "INVESTMENT INFORMATION",
          "MONTHLY OPERATING EXPENSES",
          "ASSISTANCE FROM FRIENDS AND FAMILY",
          "ASSIGN ASSET",
          "DEDICATED SAVINGS & INVESTMENTS",
          "ADD SAVINGS",
          "ADD LOAN",
        ].includes(activeTabName) && (
          <div className="descriptionDisplay">
            {payload &&
              payload["Amount Needed in Future with Inflation"] &&
              "Need: " +
                "$" +
                parseFloat(payload["Amount Needed in Future with Inflation"])
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </div>
        )
      )}
      {activeTabName &&
        [
          "PROPERTY INFORMATION",
          "COST OF LIVING ADJUSTMENT",
          "SALARY COMPARISON TOOL",
          "CHECKLIST",
          "ORIGINATION INFORMATION",
          "INVESTMENT INFORMATION",
          "MONTHLY OPERATING EXPENSES",
          "ASSISTANCE FROM FRIENDS AND FAMILY",
          "BIRTH",
          "PREPARING FOR THE NEW ARRIVAL",
          "BATH AND HEALTH",
          "TRAVEL AND TRANSPORTATION",
          "COSTS THROUGHTOUT YEAR",
          "ADDITIONAL COSTS THROUGHTOUT YEAR",
          "BOOKS, TOYS, ACTIVITIES",
          "ASSIGN ASSET",
          "DEDICATED SAVINGS & INVESTMENTS",
          "ADD SAVINGS",
          "ADD LOAN",
        ].includes(activeTabName) && (
          <div className="descriptionDisplay">
            {payload &&
              "Have: $" +
                (
                  (Array.isArray(payload["Amount Received"])
                    ? payload["Amount Received"].reduce(
                        (acc, curr) => acc + +curr,
                        0,
                      )
                    : 0) +
                  (payload["Total Monthly Saving for All Goals"]
                    ? parseFloat(payload["Total Monthly Saving for All Goals"])
                    : 0) +
                  (Array.isArray(assetsAssign)
                    ? assetsAssign.reduce(
                        (acc, curr) =>
                          acc + parseFloat(curr.amountUseForGoal || 0),
                        0,
                      )
                    : 0)
                )
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </div>
        )}
      {inputFields && inputFields.length > 0 && (
        <Styles.FormDiv>
          {inputFields &&
            inputFields.length > 0 &&
            inputFields
              .filter((field) => data && data[field]) // Ensure only valid fields are sorted
              .sort((a, b) => {
                return (
                  ((data && data[a].priority) || 0) -
                  ((data && data[b].priority) || 0)
                );
              })
              .map((item, indx) => {
                // console.log("item in mappppp", item);
                if (data && data[item] && data[item].formGroupName)
                  return <React.Fragment key={indx}></React.Fragment>;
                return (
                  <React.Fragment key={indx}>
                    {DynamicComponentGenerator(item)}
                  </React.Fragment>
                );
              })}
        </Styles.FormDiv>
      )}
      {activeTabName && activeTabName === "ADD SAVINGS" && module !== "Retirement" && (
        <GoalMonthlySavings />
      )}
      {groupedFields && groupedFields.length > 0 && (
        <div className="goalsGroupFields">
          {
            // Case 1: ADD SAVINGS -> must have dependent attributes
            (activeTabName &&
              activeTabName === "ADD SAVINGS" &&
              module !== "Retirement" &&
              isDependentAttributeTrue(dependentAttributes, payload)) ||
            // Case 2: NOT ADD SAVINGS -> show if all attributes are single
            (activeTabName &&
              activeTabName !== "ADD SAVINGS" &&
              groupedFields.some(function (group) {
                return (
                  group.groupAttributes &&
                  group.groupAttributes.length > 0 &&
                  group.groupAttributes.every(function (attr) {
                    return attr.subType === "single";
                  })
                );
              })) ? (
              <React.Fragment>
                {groupedFields.map((group) =>
                  group.groupName === "Other Retirement Income" ? (
                    <div className="goalSubFormTable">
                      <h3 className="incomecardheading">
                        Select from Income Module to add below
                      </h3>
                      <Select
                        showSearch
                        style={{ width: "15.5rem" }}
                        placeholder="Select Income"
                        // onPopupScroll={handlePopupScroll} // Pagination on scroll
                        // value={payload && payload[item.name]}
                        onChange={(value) => {
                          const selectedIncome =
                            incomeList &&
                            incomeList.find((asset) => asset.id === value);
                          const datatoAdd = {
                            key: value,
                            "Income Source Name":
                              selectedIncome["Income Name"] || "No Name",
                            "Annual Amount":
                              selectedIncome["Gross Monthly Wages"] || 0,
                          };
                          const rows = [...tabRows[activeTabName], datatoAdd];
                          handleFormInputChange(group.groupName, rows);
                        }}
                        // notFoundContent={loadingAssets ? <Spin /> : null}
                        optionLabelProp="label"
                        // dropdownStyle={{ minHeight: "3.5rem" }}
                      >
                        {incomeList &&
                          incomeList.map((income, index) => (
                            <Option
                              key={income.id}
                              value={income.id}
                              label={income["Income Name"] || "No Name"}
                            >
                              <span
                                role="img"
                                aria-label={income["Income Name"]}
                                style={{ marginRight: "8px" }}
                              >
                                <img
                                  width={32}
                                  src={income.image}
                                  alt={income["Income Name"] || "No Name"}
                                ></img>
                              </span>
                              {income["Income Name"] || "No Name"}
                            </Option>
                          ))}
                      </Select>
                      <GoalSubFormTable
                        title={group.groupName}
                        rows={
                          tabRows[activeTabName] ? tabRows[activeTabName] : []
                        }
                        colsFormat={group.cols ? group.cols : []}
                        addNewButton={view ? false : true}
                        deleteAssignAsset={(row) => {
                          if (
                            isAssignAssetTab &&
                            group.groupName === "Assets to Assign to Goal"
                          ) {
                            deleteAssignAsset(row);
                          }
                        }}
                        cbFormChange={(rows) => {
                          handleFormInputChange(group.groupName, rows);
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      key={group.groupName}
                      style={{
                        flexBasis: "100%",
                        width: "100%",
                        marginBottom: group.groupAttributes &&
                                group.groupAttributes.length > 0 && "2rem",
                      }}
                    >
                      <Collapse defaultActiveKey={[group.groupName]}>
                        <Panel header={group.groupName} key={group.groupName}>
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              gap: "1rem",
                              flexWrap: "wrap",
                            }}
                          >
                            <React.Fragment>
                              {group.groupAttributes &&
                                group.groupAttributes.length > 0 &&
                                group.groupAttributes.map((item, indx) => {
                                  return (
                                    <div key={indx}>
                                      {SubFieldGenerator(item)}
                                    </div>
                                  );
                                })}
                            </React.Fragment>
                          </div>
                        </Panel>
                      </Collapse>
                    </div>
                  ),
                )}
              </React.Fragment>
            ) : (
              groupedFields.map((group, indx) => (
                <div
                  key={group.groupName}
                  style={{ flexBasis: "100%", marginBottom: "2rem" }}
                >
                  {isDependentAttributeTrue(dependentAttributes, payload) ? (
                    <React.Fragment>
                      {activeTabName &&
                        isAssignAssetTab &&
                        (group.groupName === "Assets to Assign to Goal" ||
                          (module === "Education" && indx === 0)) &&
                        (module === "Education" ? (
                          <EducationAssetAssignTable
                            rows={
                              isAssignAssetTab &&
                              group.groupName === "Assets to Assign to Goal"
                                ? assetsAssign
                                : tabRows[activeTabName]
                                  ? tabRows[activeTabName]
                                  : []
                            }
                            data={payload}
                            attributeValues={attributeValues}
                            handleCashModuleCreate={handleCashModuleCreate}
                            allLiabilities={liabilities && liabilities}
                            cbFormChange={(rows) => {
                              handleFormInputChange(group.groupName, rows);
                              if (
                                isAssignAssetTab &&
                                group.groupName === "Assets to Assign to Goal"
                              ) {
                                setAssetsAssign(rows);
                              }
                            }}
                          />
                        ) : (
                          <AssetAssignTable
                            rows={
                              isAssignAssetTab &&
                              group.groupName === "Assets to Assign to Goal"
                                ? assetsAssign
                                : tabRows[activeTabName]
                                  ? tabRows[activeTabName]
                                  : []
                            }
                            data={payload}
                            attributeValues={attributeValues}
                            handleCashModuleCreate={handleCashModuleCreate}
                            allLiabilities={liabilities && liabilities}
                            cbFormChange={(rows) => {
                              handleFormInputChange(group.groupName, rows);
                              if (
                                isAssignAssetTab &&
                                group.groupName === "Assets to Assign to Goal"
                              ) {
                                setAssetsAssign(rows);
                              }
                            }}
                          />
                        ))}
                      {activeTabName &&
                        isAssignAssetTab &&
                        (group.groupName === "Assets to Assign to Goal" ||
                          (module === "Education" && indx === 0)) &&
                        (module === "Education" ? (
                          <EducationAssetAssignLiquid
                            rows={
                              isAssignAssetTab &&
                              group.groupName === "Assets to Assign to Goal"
                                ? assetsAssign
                                : tabRows[activeTabName]
                                  ? tabRows[activeTabName]
                                  : []
                            }
                            data={payload}
                            attributeValues={attributeValues}
                            handleLiquidModuleToUpdate={
                              handleLiquidModuleToUpdate
                            }
                            allLiabilities={liabilities && liabilities}
                            cbFormChange={(rows) => {
                              handleFormInputChange(group.groupName, rows);
                              if (
                                isAssignAssetTab &&
                                group.groupName === "Assets to Assign to Goal"
                              ) {
                                setAssetsAssign(rows);
                              }
                            }}
                          />
                        ) : (
                          <AssetAssignLiquid
                            rows={
                              isAssignAssetTab &&
                              group.groupName === "Assets to Assign to Goal"
                                ? assetsAssign
                                : tabRows[activeTabName]
                                  ? tabRows[activeTabName]
                                  : []
                            }
                            data={payload}
                            attributeValues={attributeValues}
                            handleLiquidModuleToUpdate={
                              handleLiquidModuleToUpdate
                            }
                            allLiabilities={liabilities && liabilities}
                            cbFormChange={(rows) => {
                              handleFormInputChange(group.groupName, rows);
                              if (
                                isAssignAssetTab &&
                                group.groupName === "Assets to Assign to Goal"
                              ) {
                                setAssetsAssign(rows);
                              }
                            }}
                          />
                        ))}
                      <GoalSubFormTable
                        title={group.groupName}
                        rows={
                          isAssignAssetTab &&
                          group.groupName === "Assets to Assign to Goal"
                            ? assetsAssign
                            : tabRows[activeTabName]
                              ? tabRows[activeTabName]
                              : []
                        }
                        colsFormat={
                          isAssignAssetTab &&
                          group.groupName === "Assets to Assign to Goal"
                            ? assignGoalColumns
                            : group.cols
                        }
                        addNewButton={view ? false : true}
                        deleteAssignAsset={(row) => {
                          if (
                            isAssignAssetTab &&
                            group.groupName === "Assets to Assign to Goal"
                          ) {
                            deleteAssignAsset(row);
                          }
                        }}
                        cbFormChange={(rows) => {
                          handleFormInputChange(group.groupName, rows);
                          if (
                            isAssignAssetTab &&
                            group.groupName === "Assets to Assign to Goal"
                          ) {
                            setAssetsAssign(rows);
                            console.log("rrrrrrrr", rows);
                          }
                        }}
                      />
                    </React.Fragment>
                  ) : (
                    group.groupName === "Other Retirement Income" && (
                      <div className="goalSubFormTable">
                        <h3 className="incomecardheading">
                          Select from Income Module to add below
                        </h3>
                        <Select
                          showSearch
                          style={{ width: "15.5rem" }}
                          placeholder="Select Income"
                          // onPopupScroll={handlePopupScroll} // Pagination on scroll
                          // value={payload && payload[item.name]}
                          onChange={(value) => {
                            const selectedIncome =
                              incomeList &&
                              incomeList.find((asset) => asset.id === value);
                            const datatoAdd = {
                              key: value,
                              "Income Source Name":
                                selectedIncome["Income Name"] || "No Name",
                              "Annual Amount":
                                selectedIncome["Gross Monthly Wages"] || 0,
                            };
                            const rows = [...tabRows[activeTabName], datatoAdd];
                            handleFormInputChange(group.groupName, rows);
                          }}
                          // notFoundContent={loadingAssets ? <Spin /> : null}
                          optionLabelProp="label"
                          // dropdownStyle={{ minHeight: "3.5rem" }}
                        >
                          {incomeList &&
                            incomeList.map((income, index) => (
                              <Option
                                key={income.id}
                                value={income.id}
                                label={income["Income Name"] || "No Name"}
                              >
                                <span
                                  role="img"
                                  aria-label={income["Income Name"]}
                                  style={{ marginRight: "8px" }}
                                >
                                  <img
                                    width={32}
                                    src={income.image}
                                    alt={income["Income Name"] || "No Name"}
                                  ></img>
                                </span>
                                {income["Income Name"] || "No Name"}
                              </Option>
                            ))}
                        </Select>
                        <GoalSubFormTable
                          title={group.groupName}
                          rows={
                            tabRows[activeTabName] ? tabRows[activeTabName] : []
                          }
                          colsFormat={group.cols ? group.cols : []}
                          addNewButton={view ? false : true}
                          deleteAssignAsset={(row) => {
                            if (
                              isAssignAssetTab &&
                              group.groupName === "Assets to Assign to Goal"
                            ) {
                              deleteAssignAsset(row);
                            }
                          }}
                          cbFormChange={(rows) => {
                            handleFormInputChange(group.groupName, rows);
                          }}
                        />
                      </div>
                    )
                  )}
                </div>
              ))
            )
          }
        </div>
      )}
      {/* test payload and and taxINfo data
       payload {
        "Current Age": 45,
        "Desired Retirement Age": 65,
        "Client Life Expectancy": 90,
        "Inflation rate for this goal": 3, // as percentage to test parsing
        annualReturnRate: 0.06,
        "Net Annual Post-Retirement Budget": 60000,
        "Your Estimated Social Security": 18000,
        "Social Security - Spouse": 12000,
        Pension: 5000,
        "Net Rental Income": 8000,
        "Annual Amount": [4000], // additional income array
        "Annual Salary": 90000,
        taxableBalance: 100000,
        "Taxable Accounts Balance (Brokerage, Savings)": 100000,
        taxDeferredBalance: 150000,
        "Tax-Deferred Balance": 150000,
        taxFreeBalance: 50000,
        "Tax-Free Balance": 50000,
        taxableContrib: 5000,
        taxDeferredContrib: 10000,
        taxFreeContrib: 4000,
        "Tax Filing Status": "Married Filing Jointly",
        "Spouse's Current Age": 43,
        "State of Residence in Retirement": "California",
      }
        taxinfo {
        grossIncome: 90000,
        taxFillingElection: "Married Filing Jointly",
        deductions: "standard",
        state: "California",
        city: "Los Angeles",
        hsaContributions: 0,
        studentLoan: 0,
        iraContribution: 6000,
        educatorExpenses: 0,
        careExpenses: 0,
        educationExpenses: 0,
        noOfDependents: 0,
        shortTermGainsLoss: 0,
        longTermGainsLoss: 0,
        lossCarryforward: 0,
      }
      */}
      {module === "Retirement" && activeTabName === "ASSIGN ASSET" && (
        <Styles.FormDiv>
        <AssetAssignRetirement
          rows={tabRows[activeTabName] ? tabRows[activeTabName] : []}
          data={payload}
          attributeValues={attributeValues}
          handleCashModuleCreate={handleCashModuleCreate}
          allLiabilities={liabilities && liabilities}
          incomeList={incomeList && incomeList}
          rateOfReturnData={rateOfReturnData && rateOfReturnData}
          cbFormChange={(rows) => {
            handleRetirementAssetChange(rows);
            if (isAssignAssetTab) {
              setAssetsAssign(rows);
            }
          }}
        />
        </Styles.FormDiv>
      )}
      {module === "Education" && (
        <EducationProjection
          activeTabName={activeTabName}
          taxInfo={taxInfo && taxInfo}
          payload={payload}
          rateOfReturnData={rateOfReturnData && rateOfReturnData}
          taxInfoAllData={taxInfoAllData && taxInfoAllData}
        />
      )}
      {module === "Retirement" && activeTabName === "ADD SAVINGS" && (
        <Styles.FormDiv>
          <RetirementStrategyResults
            payload={payload && payload}
            setPayload={setPayload}
            taxInfo={taxInfo && taxInfo}
            taxInfoAllData={taxInfoAllData && taxInfoAllData}
            rateOfReturnData={rateOfReturnData && rateOfReturnData}
            assetsAssign={assetsAssign && assetsAssign}
          />
        </Styles.FormDiv>
      )}
      {module &&
        module === "Retirement" &&
        payload &&
        (activeTabName !== "ADD SAVINGS" && activeTabName !== "GOAL AND PERSONAL INFORMATION") &&
        payload["Desired Retirement Age"] && (
          <RetirementProjection
            payload={payload && payload}
            taxInfo={taxInfo && taxInfo}
            rateOfReturnData={rateOfReturnData && rateOfReturnData}
            taxInfoAllData={taxInfoAllData && taxInfoAllData}
            setPayload={setPayload}
            assetsAssign={assetsAssign && assetsAssign}
          />
        )}
    </React.Fragment>
  );
};

const TabNavigationComponent = ({
  tabs,
  activeTabIndex,
  setActiveTabIndex,
  activeTabName,
  setActiveTabName,
  currentTab,
  AllTabs,
}) => {
  return (
    <div className="tab-navigation">
      <Styles.TabContainer>
        <div
          style={{
            width: "1400px",
            display: "flex",
            margin: "auto",
            justifyContent: "center",
          }}
        >
          {AllTabs &&
            Object.keys(AllTabs).map((tabName, tabIndex) => {
              return (
                <React.Fragment key={tabIndex}>
                  {tabIndex > 0 && (
                    <Styles.SpacerLine
                      activeIndex={activeTabIndex}
                      currentIndex={tabIndex}
                    ></Styles.SpacerLine>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "70px",
                    }}
                  >
                    <Styles.TabBox
                      onClick={() => {
                        if (AllTabs[tabName].enabled) {
                          currentTab(AllTabs[tabName].name);
                          setActiveTabName(AllTabs[tabName].name);
                          setActiveTabIndex(tabIndex);
                        }
                      }}
                      activeIndex={activeTabIndex}
                      currentIndex={tabIndex}
                      isActive={AllTabs[tabName].name == activeTabName}
                      isEnabled={AllTabs[tabName].enabled}
                    >
                      <Styles.TabBoxNumber>
                        {AllTabs[tabName].priority}
                      </Styles.TabBoxNumber>
                    </Styles.TabBox>
                    <p style={{ margin: "10px 0", textAlign: "center" }}>
                      {AllTabs[tabName].name}
                    </p>
                  </div>
                </React.Fragment>
              );
            })}
        </div>
      </Styles.TabContainer>
    </div>
  );
};

export default GoalAllocationSubform;
